import React, {Component} from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import * as qs from 'query-string';
import 'moment/locale/es';
import 'react-datepicker/dist/react-datepicker.css';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import Autocomplete from 'react-autocomplete';
import 'react-bootstrap-table/dist/react-bootstrap-table.min.css';
import {FadeLoader} from 'react-spinners';
import {
    fetchFichasVenta,
    fetchReporteConsultaFichaVenta,
    fetchReporteConsultaFichaVentaBonos,/*Req. 92349 ebarboza 18 06 2021 */
    fetchAreasVenta,
    loadFichasVenta,
    fetchFamilia,
    fetchFiliales,
    fetchCompanias,
    fetchZonas,
    fetchTipoFichas,
    fetchMonedas,
    fetchTipoPagos,
    fetchTipoAdquisicion,
    fetchFamiliaPorAreaVta,
    fetchVendedores,
    clearVendedores,
    fetchObtenerClientes,
    fetchobtenerAsesor,
    fetchObtenerModelo,
    fetchObtenerConfiguracion,
    fetchObtenerClausulaComra,
    PAG_0,
    PAG_1,
    CANT_X_PAG
} from '../actions';
import Mainrow from '../components/IndexFichaVenta/mainrow';
import ComboCheck from '../components/TableActions/comboCheck.js';
import NuevaFichaVenta from '../pages/modals/NuevaFichaVenta';
import updateState from '../utils/updateState';
import getFiliales from '../utils/getFiliales';
import toggleDiv from '../utils/toggleDiv';
import ErrorUIComponent from '../utils/ErrorUIComponent';
import getPedidosFechas from "../utils/getPedidosFechas";
import saveAs from '../utils/downloadFile';
import Alert from '../components/Alert';
import showModals from "../pages/DetalleFichaVenta/ContenidoTablas/showModals";
import _ from "lodash";


const COMBO_CHECK_A_VTA = 'COMBO_CHECK_A_VTA';
const COMBO_CHECK_FAMILIA = 'COMBO_CHECK_FAMILIA';
const COMBO_CHECK_FILIAL = 'COMBO_CHECK_FILIAL';
const COMBO_CHECK_COMPANIA = 'COMBO_CHECK_COMPANIA';
const COMBO_CHECK_ZONA = 'COMBO_CHECK_ZONA';
const COMBO_CHECK_TIPOFICHA = 'COMBO_CHECK_TIPOFICHA';
const COMBO_CHECK_MONEDA = 'COMBO_CHECK_MONEDA';
const COMBO_CHECK_TIPOPAGO = 'COMBO_CHECK_TIPOPAGO';
const COMBO_CHECK_MONEDACREDITO = 'COMBO_CHECK_MONEDACREDITO';
const COMBO_CHECK_TIPOADQUISICION = 'COMBO_CHECK_TIPOADQUISICION';
const COMBO_CHECK_CLAUSULAS = 'COMBO_CHECK_CLAUSULAS';


const TableTr = (props) => {
    const clientes = props.clientes;
    if (_.isArray(clientes)) {
        return props.clientes.map(cli =>
            <tr key={cli.codigo}>
                <td>{cli.codigo}</td>
                <td>{cli.nombre}</td>
                <td>{cli.ruc}</td>
                <td>{cli.dni}</td>
                <td><a className='btn btn-default btn' onClick={() => props.fnClienteSelected(cli)}><i
                    className='ion-android-arrow-dropright'/></a></td>
            </tr>
        )
    }
    return null;
};

const TableTrAsesor = (props) => {
    const asesores = props.asesores;
    if (_.isArray(asesores)) {
        return props.asesores.map(ase =>
            <tr key={ase.codVendedor}>
                <td><a className='btn btn-default btn' onClick={() => props.fnAsesorSelected(ase)}><i
                    className='ion-android-arrow-dropright'/></a></td>
                <td>{ase.nombre}</td>
                <td>{ase.codVendedor}</td>
            </tr>
        )
    }
    return null;
};

const TableTrBaumuster = (props) => {
    const baumusters = props.baumusters;
    if (_.isArray(baumusters)) {
        return props.baumusters.map(bau =>
            <tr key={bau.id}>
                <td><a className='btn btn-default btn' onClick={() => props.fnBaumusterSelected(bau)}><i
                    className='ion-android-arrow-dropright'/></a></td>
                <td>{bau.nombre}</td>
                <td>{bau.id}</td>
            </tr>
        )
    }
    return null;
};

const TableTrConfiguracion = (props) => {
    const configuraciones = props.configuraciones;
    if (_.isArray(configuraciones)) {
        return props.configuraciones.map(con =>
            <tr key={con.codConfigVeh}>
                <td>{con.desConfigVeh}</td>
                <td>{con.skuSap}</td>
                <td><a className='btn btn-default btn' onClick={() => props.fnConfiguracionSelected(con)}><i
                    className='ion-android-arrow-dropright'/></a></td>
            </tr>
        )
    }
    return null;
};

class IndexFichaVenta extends Component {
    static pillFormatter(cell) {
        switch (cell) {
            case 'CREACION':
                return <span className='pill pill-block pill-yellow'>{cell}</span>;
            case 'VIGENCIA':
                return <span className='pill pill-block pill-green'>{cell}</span>;
            case 'ANULADA':
                return <span className='pill pill-block pill-red'>{cell}</span>;
            default:
                return <span className='pill pill-block'>{cell}</span>;
        }
    }

    static hideMessage() {
        document.getElementById('alertFichaVenta').style.display = 'flex';
        setTimeout(() => {
            if (document.getElementById('alertFichaVenta')) {
                document.getElementById('alertFichaVenta').style.display = 'none';
            }
        }, 3000);
    }


    constructor(props) {
        super(props);

        const params = qs.parse(this.props.location.search);
        const modalOpen = params.cliente ? 'nueva-fdv' : '';

        this.state = {
            estado: '[C,V,E,I]',
            muestraModalMasFiltros: 'none',

            fdvSelected: [],
            comboOpen: false,

            startDateInicio: '',
            startDateFinal: '',
            searchOption: 'nfdv',
            cantidadPaginas: 0,
            totalRegistros: 0,
            nroPag: 0,
            nInicio: 0,
            nFin: 0,
            comboSelected: '',

            checkAreaVta: [],
            checkFiliales: [],
            checkFamilia: [],
            checkCompanias: [],
            checkZonas: [], //
            checkTipoFicha: [],
            checkMoneda: [],
            checkTipoPago: [],
            checkMonedaCredito: [],
            checkTipoAdquisicion: [],
            numeroInput: '',
            muestraLoad: 'block',
            searchOptionFechas: 'fcreacion',
            nomClienteInput: '',
            baumausterInput: '',
            clausulaCompraInput: '',
            configModelVehInput: '',

            colorBackground: '#fcbc61',
            iconAlert: 'ion-alert-circled',
            mensajeAlert: '',
            filialesXAreaVtaXZona: [],
            vendedorId: '',
            vendedorName: '',

            modalOpen,


            /*REQ-86298*/
            isOpenCliente: 'none',
            isOpenAsesor: 'none',
            isOpenBaumuster: 'none',
            isOpenConfiguracion: 'none',

            nombreClienteInput: '',
            dniClienteInput: '',
            rucClienteInput: '',
            clienteResponse: [],
            codClienteFiltro: '',
            nomClienteFiltro: '',
            cantidadPaginasClientes: 0,
            totalClientesRegistros: 0,
            nroPagCliente: 0,
            nInicioCliente: 0,
            nFinCliente: 0,

            asesorResponse: [],
            codigoAsesorInput: '',
            nombreAsesorInput: '',
            codAsesorFiltro: '',
            nomAsesorFiltro: '',
            cantidadPaginasAsesores: 0,
            totalAsesoresRegistros: 0,
            nroPagAsesor: 0,
            nInicioAsesor: 0,
            nFinAsesor: 0,

            baumusterResponse:[],
            codigoBaumusterInput: '',
            nombreBaumusterInput: '',
            codigoBaumusterFiltro: '',
            nombreBaumusterFiltro: '',
            cantidadPaginasBaumuster: 0,
            totalBaumusterRegistros: 0,
            nroPagBaumuster: 0,
            nInicioBaumuster: 0,
            nFinBaumuster: 0,

            configuracionResponse: [],
            codigoConfiguracionInput: '',
            nombreConfiguracionInput: '',
            codigoSKUInput: '',
            cantidadPaginasConfi: 0,
            totalConfiguracionRegistros: 0,
            nroPagConfig: 0,
            nInicioConf: 0,
            nFinConf: 0,

            codigoConfiguracionFiltro: '',
            nombreConfiguracionFiltro: '',
            codigoSKUFiltro: '',
            codigoClausulaFiltro: '',
            muestraLoad2: 'none',

            clausulas: [],
            checkClausulas: []
            /*REQ-86298*/
        };


        this.props.fetchObtenerClausulaComra()
            .then(data => {
                this.setState({clausulas: data.payload.data.itemList})
            })
        this.selectFDV = this.selectFDV.bind(this);
        this.updateFichaVentaStates = this.updateFichaVentaStates.bind(this);
        this.abrirModalMasFiltros = this.abrirModalMasFiltros.bind(this);
        this.cerrarModalMasFiltros = this.cerrarModalMasFiltros.bind(this);
        this.handleClickComboCheck = this.handleClickComboCheck.bind(this);
        this.handleInputChangeComboCheck = this.handleInputChangeComboCheck.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.atras = this.atras.bind(this);
        this.siguiente = this.siguiente.bind(this);
        this.handleClickComboCheckFiltrar = this.handleClickComboCheckFiltrar.bind(this);
        this.initPaginacion = this.initPaginacion.bind(this);
        this.changeSearchOption = this.changeSearchOption.bind(this);
        this.onChangeNumeroInput = this.onChangeNumeroInput.bind(this);
        this.searchNumero = this.searchNumero.bind(this);
        this.handleChangeInicio = this.handleChangeInicio.bind(this);
        this.handleChangeFinal = this.handleChangeFinal.bind(this);
        this.searchFechas = this.searchFechas.bind(this);
        this.changeSearchOptionFechas = this.changeSearchOptionFechas.bind(this);
        this.filtrarMas = this.filtrarMas.bind(this);
        this.cancelarModalMasFiltros = this.cancelarModalMasFiltros.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.selectFDVentaAll = this.selectFDVentaAll.bind(this);
        this.clickDescargarExcel = this.clickDescargarExcel.bind(this);
        this.clickDescargarExcelBonos = this.clickDescargarExcelBonos.bind(this);/*Req. 92349 ebarboza 18 06 2021*/
        /*REQ-86298*/
        this.openModalCliente = this.openModalCliente.bind(this);
        this.closeModalCliente = this.closeModalCliente.bind(this);
        this.obtieneClientes = this.obtieneClientes.bind(this);

        this.openModalAsesor = this.openModalAsesor.bind(this);
        this.closeModalAsesor = this.closeModalAsesor.bind(this);
        this.obtieneAsesores = this.obtieneAsesores.bind(this);

        this.openModalBaumuster = this.openModalBaumuster.bind(this);
        this.closeModalBaumuster = this.closeModalBaumuster.bind(this);
        this.obtieneBaumuster = this.obtieneBaumuster.bind(this);

        this.openModalConfiguracion = this.openModalConfiguracion.bind(this);
        this.closeModalConfiguracion = this.closeModalConfiguracion.bind(this);
        this.obtieneConfiguracion = this.obtieneConfiguracion.bind(this);

        this.initPaginacionCliente = this.initPaginacionCliente.bind(this);
        this.initPaginacionAsesor = this.initPaginacionAsesor.bind(this);
        this.initPaginacionBaumuster = this.initPaginacionBaumuster.bind(this);
        this.initPaginacionConfig = this.initPaginacionConfig.bind(this);

        this.atrasCliente = this.atrasCliente.bind(this);
        this.atrasAsesor = this.atrasAsesor.bind(this);
        this.atrasBaumuster = this.atrasBaumuster.bind(this);
        this.atrasConfig = this.atrasConfig.bind(this);

        this.siguienteCliente = this.siguienteCliente.bind(this);
        this.siguienteAsesor = this.siguienteAsesor.bind(this);
        this.siguienteBaumuster = this.siguienteBaumuster.bind(this);
        this.siguienteConfig = this.siguienteConfig.bind(this);

        /*REQ-86298*/
    }

    loading = (status) => {
        this.setState({muestraLoad: status});
    }

    descargarPDF = (reportePdf) => {
        const contentType = 'application/vnd.ms-excel';
        const b64Data = reportePdf;
        const fileName = 'ficha-de-ventas.xls';
        saveAs(b64Data, contentType, fileName);
    }

    componentDidMount() {
        document.addEventListener('click', this.handleClickComboCheck, true);
        document.addEventListener('keydown', this.onKeyDown, true);
        document.addEventListener('click', toggleDiv, true);
        this.props.loadFichasVenta();
        this.props.fetchFichasVenta('[C,V,E,I]', PAG_1, CANT_X_PAG, 'nfdv', '', 'fcreacion',
            moment(moment().subtract(1, 'month')), moment(),
            '', this.state.checkFamilia,
            this.state.checkFiliales, 
            /* I-86298 */
            this.state.checkCompanias,
            this.state.codClienteFiltro, this.state.codAsesorFiltro,
            this.state.codigoBaumusterFiltro, this.state.codigoConfiguracionFiltro,
            this.state.codigoSKUFiltro, this.state.checkClausulas,
            this.state.checkMoneda,this.state.checkZonas,this.state.checkTipoAdquisicion
            /* F-86298 */
            /*'',
            this.state.vendedorId, this.state.nomClienteInput,
            this.state.checkZonas, this.state.checkTipoFicha,
            this.state.checkMoneda, this.state.baumausterInput,
            this.state.checkTipoPago, this.state.checkMonedaCredito,
            this.state.clausulaCompraInput, this.state.configModelVehInput,
            this.state.checkTipoAdquisicion*/)
            .then((result) => {
                console.log(result);
                if (result.payload.data.estadoTrama === '1') {
                    this.initPaginacion(result.payload.data.totalRegistros,
                        result.payload.data.cantidadPaginas);
                } else if (result.payload.data.estadoTrama === '0') {
                    this.setState({
                        muestraLoad: 'none',
                        iconAlert: 'ion-close-circled',
                        colorBackground: '#F56669',
                        mensajeAlert: result.payload.data.mensaje
                    });
                    IndexFichaVenta.hideMessage();
                } else if (result.payload.data.estadoTrama === '-1') {
                    this.setState({
                        muestraLoad: 'none',
                        iconAlert: 'ion-close-circled',
                        colorBackground: '#F56669',
                        mensajeAlert: `¡Error interno del servidor:${result.payload.data.mensaje}!`
                    });
                    IndexFichaVenta.hideMessage();
                } else {
                    this.setState({
                        muestraLoad: 'none',
                        iconAlert: 'ion-close-circled',
                        colorBackground: '#F56669',
                        mensajeAlert: `¡Error interno del servidor:${result.payload.data.estadoTrama}!`
                    });
                    IndexFichaVenta.hideMessage();
                }
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    muestraLoad: 'none',
                    iconAlert: 'ion-close-circled',
                    colorBackground: '#F56669',
                    mensajeAlert: '¡Error interno del servidor!'
                });
                IndexFichaVenta.hideMessage();
            });


        this.props.fetchAreasVenta();
        // this.props.fetchFamilia();
        // this.props.fetchFiliales();
        this.props.fetchCompanias();
        this.props.fetchZonas();
        this.props.fetchTipoFichas();
        this.props.fetchMonedas();
        this.props.fetchTipoPagos();
        this.props.fetchTipoAdquisicion();
        document.title = 'Divemotor - Ficha de venta';
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickComboCheck, true);
        document.removeEventListener('keydown', this.onKeyDown, true);
        document.removeEventListener('click', toggleDiv, true);
    }

    onChangeNumeroInput(e) {
        this.setState({numeroInput: e.target.value});
    }

    onKeyDown(e) {
        const nameComponente = e.target.getAttribute('name');
        const classComponente = e.target.getAttribute('class');

        if (e.keyCode === 27) {
            document.querySelectorAll('.dropdown.dropdown-multi').forEach(dropdown => dropdown.classList.remove('open'));
            this.cerrarModalMasFiltros();
        }
        if (e.keyCode === 13) {
            if (nameComponente === 'btnDropdownToggle' || nameComponente === 'iconDropdownToggle'
                || (classComponente !== null && classComponente.indexOf('checkDeGrillaEnterCerrar') >= 0)) {
                this.setState({fdvSelected: []});
                if (document.getElementById('checkBoxAll') !== null) {
                    document.getElementById('checkBoxAll').checked = false;
                }
            }
        }
    }

    setNroPag(nuevoTotalRegistros) {
        if (nuevoTotalRegistros < 1) {
            this.setState({nroPag: PAG_0});
        } else if (this.state.nroPag === 0) { // iniciacion
            this.setState({nroPag: PAG_1});
        }
    }

    setNroPagCliente(nuevoTotalRegistros) {
        if (nuevoTotalRegistros < 1) {
            this.setState({nroPagCliente: PAG_0});
        } else if (this.state.nroPagCliente === 0) { // iniciacion
            this.setState({nroPagCliente: PAG_1});
        }
        console.log("llega a numpag : ", this.state.nroPagCliente);
    }

    setNroPagAsesor(nuevoTotalRegistros) {
        if (nuevoTotalRegistros < 1) {
            this.setState({nroPagAsesor: PAG_0});
        } else if (this.state.nroPagAsesor === 0) { // iniciacion
            this.setState({nroPagAsesor: PAG_1});
        }
    }

    setNroPagBaumuster(nuevoTotalRegistros) {
        if (nuevoTotalRegistros < 1) {
            this.setState({nroPagBaumuster: PAG_0});
        } else if (this.state.nroPagBaumuster === 0) { // iniciacion
            this.setState({nroPagBaumuster: PAG_1});
        }
    }

    setNroPagConfig(nuevoTotalRegistros) {
        if (nuevoTotalRegistros < 1) {
            this.setState({nroPagConfig: PAG_0});
        } else if (this.state.nroPagConfig === 0) { // iniciacion
            this.setState({nroPagConfig: PAG_1});
        }
    }



    setNInicio(nuevoTotalRegistros) {
        if (nuevoTotalRegistros < 1) {
            this.setState({nInicio: PAG_0});
        } else if (this.state.nInicio === 0) { // iniciacion
            this.setState({nInicio: PAG_1});
        }
    }

    setNInicioCliente(nuevoTotalRegistros) {
        if (nuevoTotalRegistros < 1) {
            this.setState({nInicioCliente: PAG_0});
        } else if (this.state.nInicioCliente === 0) { // iniciacion
            this.setState({nInicioCliente: PAG_1});
        }
    }

    setNInicioAsesor(nuevoTotalRegistros) {
        if (nuevoTotalRegistros < 1) {
            this.setState({nInicioAsesor: PAG_0});
        } else if (this.state.nInicioAsesor === 0) { // iniciacion
            this.setState({nInicioAsesor: PAG_1});
        }
    }

    setNInicioBaumuster(nuevoTotalRegistros) {
        if (nuevoTotalRegistros < 1) {
            this.setState({nInicioBaumuster: PAG_0});
        } else if (this.state.nInicioBaumuster === 0) { // iniciacion
            this.setState({nInicioBaumuster: PAG_1});
        }
    }

    setNInicioConfig(nuevoTotalRegistros) {
        if (nuevoTotalRegistros < 1) {
            this.setState({nInicioConf: PAG_0});
        } else if (this.state.nInicioConf === 0) { // iniciacion
            this.setState({nInicioConf: PAG_1});
        }
    }

    setNFin(nuevoTotalRegistros) {
        if (nuevoTotalRegistros < 1) {
            this.setState({nFin: PAG_0});
        } else if (nuevoTotalRegistros === CANT_X_PAG) {
            this.setState({nFin: CANT_X_PAG});
        } else if (nuevoTotalRegistros < CANT_X_PAG) {
            this.setState({nFin: nuevoTotalRegistros});
        } else if (this.state.nFin === 0) { // iniciacion
            this.setState({nFin: CANT_X_PAG});
        } else if (this.state.nInicio === 1) {
            this.setState({nFin: CANT_X_PAG});
        }
    }

    setNFinCliente(nuevoTotalRegistros) {
        if (nuevoTotalRegistros < 1) {
            this.setState({nFinCliente: PAG_0});
        } else if (nuevoTotalRegistros === CANT_X_PAG) {
            this.setState({nFinCliente: CANT_X_PAG});
        } else if (nuevoTotalRegistros < CANT_X_PAG) {
            this.setState({nFinCliente: nuevoTotalRegistros});
        } else if (this.state.nFinCliente === 0) { // iniciacion
            this.setState({nFinCliente: CANT_X_PAG});
        } else if (this.state.nInicioCliente === 1) {
            this.setState({nFinCliente: CANT_X_PAG});
        }
    }

    setNFinAsesor(nuevoTotalRegistros) {
        if (nuevoTotalRegistros < 1) {
            this.setState({nFinAsesor: PAG_0});
        } else if (nuevoTotalRegistros === CANT_X_PAG) {
            this.setState({nFinAsesor: CANT_X_PAG});
        } else if (nuevoTotalRegistros < CANT_X_PAG) {
            this.setState({nFinAsesor: nuevoTotalRegistros});
        } else if (this.state.nFinAsesor === 0) { // iniciacion
            this.setState({nFinAsesor: CANT_X_PAG});
        } else if (this.state.nInicioAsesor === 1) {
            this.setState({nFinAsesor: CANT_X_PAG});
        }
    }

    setNFinBaumuster(nuevoTotalRegistros) {
        if (nuevoTotalRegistros < 1) {
            this.setState({nFinBaumuster: PAG_0});
        } else if (nuevoTotalRegistros === CANT_X_PAG) {
            this.setState({nFinBaumuster: CANT_X_PAG});
        } else if (nuevoTotalRegistros < CANT_X_PAG) {
            this.setState({nFinBaumuster: nuevoTotalRegistros});
        } else if (this.state.nFinBaumuster === 0) { // iniciacion
            this.setState({nFinBaumuster: CANT_X_PAG});
        } else if (this.state.nInicioBaumuster === 1) {
            this.setState({nFinBaumuster: CANT_X_PAG});
        }
    }

    setNFinConfig(nuevoTotalRegistros) {
        if (nuevoTotalRegistros < 1) {
            this.setState({nFinConf: PAG_0});
        } else if (nuevoTotalRegistros === CANT_X_PAG) {
            this.setState({nFinConf: CANT_X_PAG});
        } else if (nuevoTotalRegistros < CANT_X_PAG) {
            this.setState({nFinConf: nuevoTotalRegistros});
        } else if (this.state.nFinConf === 0) { // iniciacion
            this.setState({nFinConf: CANT_X_PAG});
        } else if (this.state.nInicioConf === 1) {
            this.setState({nFinConf: CANT_X_PAG});
        }
    }

    setToCero(totalReg = PAG_0) {
        this.setNroPag(totalReg);
        this.setNInicio(totalReg);
        this.setNFin(totalReg);
        this.setState({totalRegistros: totalReg});
    }

    openModal = modal => this.setState({modalOpen: modal})
    closeModal = () => this.setState({modalOpen: ''})

    selectFDV(fdv) {
        const {fdvSelected} = this.state;
        if (fdvSelected.indexOf(fdv) >= 0) {
            this.setState({fdvSelected: fdvSelected.filter(f => f !== fdv)});
        } else {
            this.setState({fdvSelected: [...fdvSelected, fdv]});
        }
        this.setState({comboOpen: false});
    }

    validacionGrilla() {
        let ocurrioError = false;
        let ocurrioErrorMensaje = '¡Ingrese datos validos!';
        let dateInicio = document.getElementById('startDateInicioInput').value;
        let dateFinal = document.getElementById('startDateFinalInput').value;
        if (dateInicio === '' && dateFinal === '') {
            ocurrioError = false;
        } else if (!moment(dateInicio, 'DD/MM/YYYY', true).isValid()) {
            ocurrioError = true;
            ocurrioErrorMensaje = '¡La fecha inicio es invalida, ingrese una valida, ejemplo:25/12/2017!';
        } else if (!moment(dateFinal, 'DD/MM/YYYY', true).isValid()) {
            ocurrioError = true;
            ocurrioErrorMensaje = '¡La fecha fin es invalida, ingrese una valida, ejemplo:25/12/2017!';
        } else if (!(moment(dateInicio, 'DD/MM/YYYY').toDate() <= moment(dateFinal, 'DD/MM/YYYY').toDate())) {
            ocurrioError = true;
            ocurrioErrorMensaje = '¡La fecha inicio tiene que ser menor ala fecha fin!';
        } else {
            dateInicio = moment(dateInicio, 'DD/MM/YYYY');
            dateFinal = moment(dateFinal, 'DD/MM/YYYY');
        }
        return {ocurrioError, ocurrioErrorMensaje, dateInicio, dateFinal};
    }

    search(estadoSeleccionado, paginaActual, cantidadPorPagina, dateInicio, dateFinal) {
        if (document.getElementById('checkBoxAll') !== null) {
            document.getElementById('checkBoxAll').checked = false;
        }
        if (dateInicio === '') {
            dateInicio = this.state.startDateInicio;
        }
        if (dateFinal === '') {
            dateFinal = this.state.startDateFinal;
        }
        this.props.loadFichasVenta();
        console.log("search " + this.state.checkClausulas);
        this.props.fetchFichasVenta(estadoSeleccionado, paginaActual, cantidadPorPagina,
            this.state.searchOption, this.state.numeroInput,
            this.state.searchOptionFechas, dateInicio, dateFinal,
            this.state.checkAreaVta, this.state.checkFamilia,
            this.state.checkFiliales, this.state.checkCompanias,
            this.state.codClienteFiltro, this.state.codAsesorFiltro,
            this.state.codigoBaumusterFiltro, this.state.codigoConfiguracionFiltro,
            this.state.codigoSKUFiltro, this.state.checkClausulas,
            this.state.checkMoneda,this.state.checkZonas,this.state.checkTipoAdquisicion
            /*this.state.vendedorId, this.state.nomClienteInput,
            this.state.checkZonas, this.state.checkTipoFicha,
            this.state.checkMoneda, this.state.baumausterInput,
            this.state.checkTipoPago, this.state.checkMonedaCredito,
            this.state.clausulaCompraInput, this.state.configModelVehInput,
            this.state.checkTipoAdquisicion*/
        ).then((result) => {
            if (result.payload.data.estadoTrama === '1') {
                this.initPaginacion(result.payload.data.totalRegistros,
                    result.payload.data.cantidadPaginas);
            } else if (result.payload.data.estadoTrama === '0') {
                this.setState({
                    muestraLoad: 'none',
                    iconAlert: 'ion-close-circled',
                    colorBackground: '#F56669',
                    mensajeAlert: result.payload.data.mensaje
                });
                IndexFichaVenta.hideMessage();
            } else if (result.payload.data.estadoTrama === '-1') {
                this.setState({
                    muestraLoad: 'none',
                    iconAlert: 'ion-close-circled',
                    colorBackground: '#F56669',
                    mensajeAlert: `¡Error interno del servidor:${result.payload.data.mensaje}!`
                });
                IndexFichaVenta.hideMessage();
            } else {
                this.setState({
                    muestraLoad: 'none',
                    iconAlert: 'ion-close-circled',
                    colorBackground: '#F56669',
                    mensajeAlert: `¡Error interno del servidor:${result.payload.data.estadoTrama}!`
                });
                IndexFichaVenta.hideMessage();
            }
        })
            .catch(() => {
                this.setState({
                    muestraLoad: 'none',
                    iconAlert: 'ion-close-circled',
                    colorBackground: '#F56669',
                    mensajeAlert: '¡Error interno del servidor!'
                });
                IndexFichaVenta.hideMessage();
            });
    }

    searchFechas() {
        const validacion = this.validacionGrilla();
        if (validacion.ocurrioError) {
            this.setState({
                muestraLoad: 'none',
                iconAlert: 'ion-alert-circled',
                colorBackground: '#fcbc61',
                mensajeAlert: validacion.ocurrioErrorMensaje
            });
            IndexFichaVenta.hideMessage();
        } else {
            this.setState({muestraLoad: 'block'});
            this.search(this.state.estado, PAG_1, CANT_X_PAG,
                validacion.dateInicio, validacion.dateFinal);
        }
    }

    searchNumero() {
        const validacion = this.validacionGrilla();
        if (validacion.ocurrioError) {
            this.setState({
                muestraLoad: 'none',
                iconAlert: 'ion-alert-circled',
                colorBackground: '#fcbc61',
                mensajeAlert: validacion.ocurrioErrorMensaje
            });
            IndexFichaVenta.hideMessage();
        } else {
            this.setState({muestraLoad: 'block'});
            this.search(this.state.estado, PAG_1, CANT_X_PAG,
                validacion.dateInicio, validacion.dateFinal);
        }
    }

    handleClickComboCheckFiltrar() {
        const validacion = this.validacionGrilla();
        if (validacion.ocurrioError) {
            this.setState({
                muestraLoad: 'none',
                iconAlert: 'ion-alert-circled',
                colorBackground: '#fcbc61',
                mensajeAlert: validacion.ocurrioErrorMensaje
            });
            IndexFichaVenta.hideMessage();
        } else {
            this.setState({muestraLoad: 'block', comboSelected: ''});
            this.search(this.state.estado, PAG_1, CANT_X_PAG,
                validacion.dateInicio, validacion.dateFinal);
        }
        document.querySelectorAll('.dropdown.dropdown-multi').forEach(dropdown => dropdown.classList.remove('open'));

    }

    filtrarMas() {
        const validacion = this.validacionGrilla();
        if (validacion.ocurrioError) {
            this.setState({
                muestraLoad: 'none',
                iconAlert: 'ion-alert-circled',
                colorBackground: '#fcbc61',
                mensajeAlert: validacion.ocurrioErrorMensaje
            });
            IndexFichaVenta.hideMessage();
        } else {
            this.cerrarModalMasFiltros();
            this.setState({muestraLoad: 'block', comboSelected: ''});
            this.search(this.state.estado, PAG_1, CANT_X_PAG,
                validacion.dateInicio, validacion.dateFinal);
        }
    }

    siguiente() {
        let okSiguiente = false;
        let nroPag;
        if (this.state.cantidadPaginas > this.state.nroPag) {
            nroPag = this.state.nroPag + 1;
            okSiguiente = true;
        }
        if (okSiguiente) {
            const validacion = this.validacionGrilla();
            if (validacion.ocurrioError) {
                this.setState({
                    muestraLoad: 'none',
                    iconAlert: 'ion-alert-circled',
                    colorBackground: '#fcbc61',
                    mensajeAlert: validacion.ocurrioErrorMensaje
                });
                IndexFichaVenta.hideMessage();
            } else {
                this.setState({nroPag});
                if ((this.state.nFin + CANT_X_PAG) < this.state.totalRegistros) {
                    this.setState({nFin: this.state.nFin + CANT_X_PAG});
                } else {
                    this.setState({nFin: this.state.totalRegistros});
                }
                if (this.state.nInicio < this.state.totalRegistros) {
                    this.setState({nInicio: this.state.nInicio + CANT_X_PAG});
                }
                this.setState({muestraLoad: 'block'});
                this.search(this.state.estado, nroPag, CANT_X_PAG,
                    validacion.dateInicio, validacion.dateFinal);
            }
        }
    }

    siguienteCliente() {
        let okSiguiente = false;
        let nroPag;
        if (this.state.cantidadPaginasClientes > this.state.nroPagCliente) {
            nroPag = this.state.nroPagCliente + 1;
            okSiguiente = true;
        }
        if (okSiguiente) {
            const validacion = this.validacionGrilla();
            if (validacion.ocurrioError) {
                this.setState({
                    muestraLoad: 'none',
                    iconAlert: 'ion-alert-circled',
                    colorBackground: '#fcbc61',
                    mensajeAlert: validacion.ocurrioErrorMensaje
                });
                IndexFichaVenta.hideMessage();
            } else {
                this.setState({nroPagCliente : nroPag });
                if ((this.state.nFinCliente + CANT_X_PAG) < this.state.totalClientesRegistros) {
                    this.setState({nFinCliente: this.state.nFinCliente + CANT_X_PAG});
                } else {
                    this.setState({nFinCliente: this.state.totalClientesRegistros});
                }
                if (this.state.nInicioCliente < this.state.totalClientesRegistros) {
                    this.setState({nInicioCliente: this.state.nInicioCliente + CANT_X_PAG});
                }
                this.setState({muestraLoad: 'block'});
                this.props.fetchObtenerClientes(this.state.nombreClienteInput, this.state.rucClienteInput, this.state.dniClienteInput, '', nroPag, CANT_X_PAG)
                    .then(data => {
                        this.setState({clienteResponse: data.payload.data.data})
                        this.setState({muestraLoad2: 'none'})
                        this.initPaginacionCliente(data.payload.data.cantidad,
                            data.payload.data.numerodePaginas);
                    });
            }
        }
    }

    siguienteAsesor() {
        let okSiguiente = false;
        let nroPag;
        if (this.state.cantidadPaginasAsesores > this.state.nroPagAsesor) {
            nroPag = this.state.nroPagAsesor + 1;
            okSiguiente = true;
        }
        if (okSiguiente) {
            const validacion = this.validacionGrilla();
            if (validacion.ocurrioError) {
                this.setState({
                    muestraLoad: 'none',
                    iconAlert: 'ion-alert-circled',
                    colorBackground: '#fcbc61',
                    mensajeAlert: validacion.ocurrioErrorMensaje
                });
                IndexFichaVenta.hideMessage();
            } else {
                this.setState({nroPagAsesor: nroPag});
                if ((this.state.nFinAsesor + CANT_X_PAG) < this.state.totalAsesoresRegistros) {
                    this.setState({nFinAsesor: this.state.nFinAsesor + CANT_X_PAG});
                } else {
                    this.setState({nFinAsesor: this.state.totalAsesoresRegistros});
                }
                if (this.state.nInicioAsesor < this.state.totalAsesoresRegistros) {
                    this.setState({nInicioAsesor: this.state.nInicioAsesor + CANT_X_PAG});
                }
                this.setState({muestraLoad: 'block'});
                this.props.fetchobtenerAsesor(this.state.codigoAsesorInput, this.state.nombreAsesorInput, nroPag, CANT_X_PAG)
                    .then(data => {
                        this.setState({asesorResponse: data.payload.data.listVendedor})
                        this.setState({muestraLoad2: 'none'});
                        this.initPaginacionAsesor(data.payload.data.cantidad,
                            data.payload.data.numerodePaginas);
                    });
            }
        }
    };

    siguienteBaumuster() {
        let okSiguiente = false;
        let nroPag;
        if (this.state.cantidadPaginasBaumuster > this.state.nroPagBaumuster) {
            nroPag = this.state.nroPagBaumuster + 1;
            okSiguiente = true;
        }
        if (okSiguiente) {
            const validacion = this.validacionGrilla();
            if (validacion.ocurrioError) {
                this.setState({
                    muestraLoad: 'none',
                    iconAlert: 'ion-alert-circled',
                    colorBackground: '#fcbc61',
                    mensajeAlert: validacion.ocurrioErrorMensaje
                });
                IndexFichaVenta.hideMessage();
            } else {
                this.setState({nroPagBaumuster: nroPag});
                if ((this.state.nFinBaumuster + CANT_X_PAG) < this.state.totalBaumusterRegistros) {
                    this.setState({nFinBaumuster: this.state.nFinBaumuster + CANT_X_PAG});
                } else {
                    this.setState({nFinBaumuster: this.state.totalBaumusterRegistros});
                }
                if (this.state.nInicioBaumuster < this.state.totalBaumusterRegistros) {
                    this.setState({nInicioBaumuster: this.state.nInicioBaumuster + CANT_X_PAG});
                }
                this.setState({muestraLoad: 'block'});
                this.props.fetchObtenerModelo(this.state.codigoBaumusterInput, this.state.nombreBaumusterInput, this.state.nroPagBaumuster + 1, CANT_X_PAG)
                    .then(data => {
                        this.setState({baumusterResponse: data.payload.data.listModelo})
                        this.setState({muestraLoad2: 'none'});
                        this.initPaginacionBaumuster(data.payload.data.cantidad,
                            data.payload.data.numerodePaginas);
                    });
            }
        }
    };

    siguienteConfig() {
        let okSiguiente = false;
        let nroPag;
        if (this.state.cantidadPaginasConfi > this.state.nroPagConfig) {
            nroPag = this.state.nroPagConfig + 1;
            okSiguiente = true;
        }
        if (okSiguiente) {
            const validacion = this.validacionGrilla();
            if (validacion.ocurrioError) {
                this.setState({
                    muestraLoad: 'none',
                    iconAlert: 'ion-alert-circled',
                    colorBackground: '#fcbc61',
                    mensajeAlert: validacion.ocurrioErrorMensaje
                });
                IndexFichaVenta.hideMessage();
            } else {
                this.setState({nroPagConfig: nroPag});
                if ((this.state.nFinConf + CANT_X_PAG) < this.state.totalConfiguracionRegistros) {
                    this.setState({nFinConf: this.state.nFinConf + CANT_X_PAG});
                } else {
                    this.setState({nFinConf: this.state.totalConfiguracionRegistros});
                }
                if (this.state.nInicioConf < this.state.totalConfiguracionRegistros) {
                    this.setState({nInicioConf: this.state.nInicioConf + CANT_X_PAG});
                }
                this.setState({muestraLoad: 'block'});
                this.props.fetchObtenerConfiguracion(this.state.nombreConfiguracionInput, this.state.codigoSKUInput, nroPag, CANT_X_PAG)
                    .then(data => {
                        this.setState({configuracionResponse: data.payload.data.busqueda})
                        this.setState({muestraLoad2: 'none'});
                        this.initPaginacionConfig(data.payload.data.totalRegistros,
                            data.payload.data.totalPaginacion);
                    });
            }
        }
    };

    atras() {
        let okAtras = false;
        let nroPag;
        if (this.state.nroPag > 1) {
            nroPag = this.state.nroPag - 1;
            okAtras = true;
        }
        if (okAtras) {
            const validacion = this.validacionGrilla();
            if (validacion.ocurrioError) {
                this.setState({
                    muestraLoad: 'none',
                    iconAlert: 'ion-alert-circled',
                    colorBackground: '#fcbc61',
                    mensajeAlert: validacion.ocurrioErrorMensaje
                });
                IndexFichaVenta.hideMessage();
            } else {
                this.setState({nroPag});
                if (this.state.nFin === this.state.totalRegistros) {
                    this.setState({nFin: this.state.nInicio - 1});
                } else if ((this.state.nFin - CANT_X_PAG) < this.state.totalRegistros &&
                    (this.state.nFin - CANT_X_PAG) !== this.state.totalRegistros) {
                    this.setState({nFin: this.state.nFin - CANT_X_PAG});
                }
                if (this.state.nInicio <= this.state.totalRegistros) {
                    this.setState({nInicio: this.state.nInicio - CANT_X_PAG});
                }
                this.setState({muestraLoad: 'block'});
                this.search(this.state.estado, nroPag, CANT_X_PAG,
                    validacion.dateInicio, validacion.dateFinal);
            }
        }
    }

    atrasCliente() {
        console.log("PULPIN")
        let okAtras = false;
        let nroPag;
        if (this.state.nroPagCliente > 1) {
            nroPag = this.state.nroPagCliente - 1;
            okAtras = true;
        }
        if (okAtras) {
            const validacion = this.validacionGrilla();
            if (validacion.ocurrioError) {
                this.setState({
                    muestraLoad: 'none',
                    iconAlert: 'ion-alert-circled',
                    colorBackground: '#fcbc61',
                    mensajeAlert: validacion.ocurrioErrorMensaje
                });
                IndexFichaVenta.hideMessage();
            } else {
                this.setState({nroPagCliente: nroPag});
                if (this.state.nFinCliente === this.state.totalClientesRegistros) {
                    this.setState({nFinCliente: this.state.nInicioCliente - 1});
                } else if ((this.state.nFinCliente - CANT_X_PAG) < this.state.totalClientesRegistros &&
                    (this.state.nFinCliente - CANT_X_PAG) !== this.state.totalClientesRegistros) {
                    this.setState({nFinCliente: this.state.nFinCliente - CANT_X_PAG});
                }
                if (this.state.nInicioCliente <= this.state.totalClientesRegistros) {
                    this.setState({nInicioCliente: this.state.nInicioCliente - CANT_X_PAG});
                }
                this.setState({muestraLoad: 'block'});
                this.props.fetchObtenerClientes(this.state.nombreClienteInput, this.state.rucClienteInput, this.state.dniClienteInput, '', nroPag, CANT_X_PAG)
                    .then(data => {
                        this.setState({clienteResponse: data.payload.data.data})
                        this.setState({muestraLoad2: 'none'})
                        this.initPaginacionCliente(data.payload.data.cantidad,
                            data.payload.data.numerodePaginas);
                    });
            }
        }
    };

    atrasAsesor() {
        let okAtras = false;
        let nroPag;
        if (this.state.nroPagAsesor > 1) {
            nroPag = this.state.nroPagAsesor - 1;
            okAtras = true;
        }
        if (okAtras) {
            const validacion = this.validacionGrilla();
            if (validacion.ocurrioError) {
                this.setState({
                    muestraLoad: 'none',
                    iconAlert: 'ion-alert-circled',
                    colorBackground: '#fcbc61',
                    mensajeAlert: validacion.ocurrioErrorMensaje
                });
                IndexFichaVenta.hideMessage();
            } else {
                this.setState({nroPagAsesor: nroPag});
                if (this.state.nFinAsesor === this.state.totalAsesoresRegistros) {
                    this.setState({nFinAsesor: this.state.nInicioAsesor - 1});
                } else if ((this.state.nFinAsesor - CANT_X_PAG) < this.state.totalAsesoresRegistros &&
                    (this.state.nFinAsesor - CANT_X_PAG) !== this.state.totalAsesoresRegistros) {
                    this.setState({nFinAsesor: this.state.nFinAsesor - CANT_X_PAG});
                }
                if (this.state.nInicioAsesor <= this.state.totalAsesoresRegistros) {
                    this.setState({nInicioAsesor: this.state.nInicioAsesor - CANT_X_PAG});
                }
                this.setState({muestraLoad: 'block'});
                this.props.fetchobtenerAsesor(this.state.codigoAsesorInput, this.state.nombreAsesorInput, nroPag, CANT_X_PAG)
                    .then(data => {
                        this.setState({asesorResponse: data.payload.data.listVendedor})
                        this.setState({muestraLoad2: 'none'});
                        this.initPaginacionAsesor(data.payload.data.cantidad,
                            data.payload.data.numerodePaginas);
                    });
            }
        }
    }

    atrasBaumuster() {
        let okAtras = false;
        let nroPag;
        if (this.state.nroPagBaumuster > 1) {
            nroPag = this.state.nroPagBaumuster - 1;
            okAtras = true;
        }
        if (okAtras) {
            const validacion = this.validacionGrilla();
            if (validacion.ocurrioError) {
                this.setState({
                    muestraLoad: 'none',
                    iconAlert: 'ion-alert-circled',
                    colorBackground: '#fcbc61',
                    mensajeAlert: validacion.ocurrioErrorMensaje
                });
                IndexFichaVenta.hideMessage();
            } else {
                this.setState({nroPagBaumuster: nroPag});
                if (this.state.nFinBaumuster === this.state.totalBaumusterRegistros) {
                    this.setState({nFinBaumuster: this.state.nInicioBaumuster - 1});
                } else if ((this.state.nFinBaumuster - CANT_X_PAG) < this.state.totalBaumusterRegistros &&
                    (this.state.nFinBaumuster - CANT_X_PAG) !== this.state.totalBaumusterRegistros) {
                    this.setState({nFinBaumuster: this.state.nFinBaumuster - CANT_X_PAG});
                }
                if (this.state.nInicioBaumuster <= this.state.totalBaumusterRegistros) {
                    this.setState({nInicioBaumuster: this.state.nInicioBaumuster - CANT_X_PAG});
                }
                this.setState({muestraLoad: 'block'});
                this.props.fetchObtenerModelo(this.state.codigoBaumusterInput, this.state.nombreBaumusterInput, nroPag, CANT_X_PAG)
                    .then(data => {
                        this.setState({baumusterResponse: data.payload.data.listModelo})
                        this.setState({muestraLoad2: 'none'});
                        this.initPaginacionBaumuster(data.payload.data.cantidad,
                            data.payload.data.numerodePaginas);
                    });
            }
        }
    }

    atrasConfig() {
        let okAtras = false;
        let nroPag;
        if (this.state.nroPagConfig > 1) {
            nroPag = this.state.nroPagConfig - 1;
            okAtras = true;
        }
        if (okAtras) {
            const validacion = this.validacionGrilla();
            if (validacion.ocurrioError) {
                this.setState({
                    muestraLoad: 'none',
                    iconAlert: 'ion-alert-circled',
                    colorBackground: '#fcbc61',
                    mensajeAlert: validacion.ocurrioErrorMensaje
                });
                IndexFichaVenta.hideMessage();
            } else {
                this.setState({nroPagConfig: nroPag});
                if (this.state.nFinConf === this.state.totalConfiguracionRegistros) {
                    this.setState({nFinConf: this.state.nInicioConf - 1});
                } else if ((this.state.nFinConf - CANT_X_PAG) < this.state.totalConfiguracionRegistros &&
                    (this.state.nFinConf - CANT_X_PAG) !== this.state.totalConfiguracionRegistros) {
                    this.setState({nFinConf: this.state.nFinConf - CANT_X_PAG});
                }
                if (this.state.nInicioConf <= this.state.totalConfiguracionRegistros) {
                    this.setState({nInicioConf: this.state.nInicioConf - CANT_X_PAG});
                }
                this.setState({muestraLoad: 'block'});
                this.props.fetchObtenerConfiguracion(this.state.nombreConfiguracionInput, this.state.codigoSKUInput, nroPag, CANT_X_PAG)
                    .then(data => {
                        this.setState({configuracionResponse: data.payload.data.busqueda})
                        this.setState({muestraLoad2: 'none'});
                        this.initPaginacionConfig(data.payload.data.totalRegistros,
                            data.payload.data.totalPaginacion);
                    });
            }
        }
    }

    handleClick(estadoNuevo) {
        const validacion = this.validacionGrilla();
        if (validacion.ocurrioError) {
            this.setState({
                muestraLoad: 'none',
                iconAlert: 'ion-alert-circled',
                colorBackground: '#fcbc61',
                mensajeAlert: validacion.ocurrioErrorMensaje
            });
            IndexFichaVenta.hideMessage();
        } else {
            this.setState({muestraLoad: 'block', estado: estadoNuevo, nInicio: PAG_1, nroPag: PAG_1});
            this.search(estadoNuevo, PAG_1, CANT_X_PAG, validacion.dateInicio, validacion.dateFinal);
        }
    }

    updateFichaVentaStates(codigo) {
        this.setState({muestraLoad: 'block'});
        const promises = [];
        this.state.fdvSelected.map(fdv => promises.push(updateState(fdv, codigo, '')));
        Promise.all(promises)
            .then(() => this.props.fetchFichasVenta('[C,V,E,I]'))
            .then(() => this.setState({muestraLoad: 'none', comboOpen: false, fdvSelected: []}));
    }

    handleChangeInicio(date) {
        this.setState({startDateInicio: date});
    }

    handleChangeFinal(date) {
        this.setState({startDateFinal: date});
    }

    changeSearchOption(e) {
        this.setState({searchOption: e.target.value, numeroInput: ''});
    }

    changeSearchOptionFechas(e) {
        this.setState({searchOptionFechas: e.target.value});
    }


    handleChange(date) {
        this.setState({startDate: date});
    }

    initPaginacion(totalRegistros, cantidadPaginas) {
        this.setState({
            muestraLoad: 'none',
            totalRegistros: parseInt(totalRegistros, 10),
            cantidadPaginas: parseInt(cantidadPaginas, 10),
        });
        this.setNroPag(totalRegistros);
        this.setNInicio(totalRegistros);
        this.setNFin(totalRegistros);
    }

    initPaginacionCliente(totalRegistros, cantidadPaginas) {
        this.setState({
            muestraLoad: 'none',
            totalClientesRegistros: parseInt(totalRegistros, 10),
            cantidadPaginasClientes: parseInt(cantidadPaginas, 10),
        });
        this.setNroPagCliente(totalRegistros);
        this.setNInicioCliente(totalRegistros);
        this.setNFinCliente(totalRegistros);
    }

    initPaginacionAsesor(totalRegistros, cantidadPaginas) {
        this.setState({
            muestraLoad: 'none',
            totalAsesoresRegistros: parseInt(totalRegistros, 10),
            cantidadPaginasAsesores: parseInt(cantidadPaginas, 10),
        });
        this.setNroPagAsesor(totalRegistros);
        this.setNInicioAsesor(totalRegistros);
        this.setNFinAsesor(totalRegistros);
    }

    initPaginacionBaumuster(totalRegistros, cantidadPaginas) {
        this.setState({
            muestraLoad: 'none',
            totalBaumusterRegistros: parseInt(totalRegistros, 10),
            cantidadPaginasBaumuster: parseInt(cantidadPaginas, 10),
        });
        this.setNroPagBaumuster(totalRegistros);
        this.setNInicioBaumuster(totalRegistros);
        this.setNFinBaumuster(totalRegistros);
    }

    initPaginacionConfig(totalRegistros, cantidadPaginas) {
        this.setState({
            muestraLoad: 'none',
            totalConfiguracionRegistros: parseInt(totalRegistros, 10),
            cantidadPaginasConfi: parseInt(cantidadPaginas, 10),
        });
        this.setNroPagConfig(totalRegistros);
        this.setNInicioConfig(totalRegistros);
        this.setNFinConfig(totalRegistros);
    }

    abrirModalMasFiltros() {
        this.setState({muestraModalMasFiltros: 'block'});
    }

    cerrarModalMasFiltros() {
        this.setState({muestraModalMasFiltros: 'none'});
    }

    /*REQ-86298*/
    openModalCliente() {
        this.setState({isOpenCliente: 'block'});
    }

    closeModalCliente() {
        //this.state.isOpenCliente = 'none';
        this.setState({isOpenCliente: 'none'});
    }

    openModalAsesor(){
        this.setState({isOpenAsesor: 'block'})
    }

    closeModalAsesor() {
        //this.state.isOpenCliente = 'none';
        this.setState({isOpenAsesor: 'none'});
    }

    openModalBaumuster(){
        this.setState({isOpenBaumuster: 'block'});
    }

    closeModalBaumuster(){
        this.setState({isOpenBaumuster: 'none'});
    }

    openModalConfiguracion(){
        this.setState({isOpenConfiguracion: 'block'});
    }

    closeModalConfiguracion(){
        this.setState({isOpenConfiguracion: 'none'});
    }

    /*REQ-86298*/


    handleClickComboCheck(e) {
        const nameComponente = e.target.getAttribute('name');
        const idComponente = e.target.getAttribute('id');
        const classComponente = e.target.getAttribute('class');

        if (nameComponente === 'btnDropdownToggle' || nameComponente === 'iconDropdownToggle'
            || (classComponente !== null && classComponente.indexOf('checkDeGrillaCerrar') >= 0)) {
            this.setState({fdvSelected: []});
            if (document.getElementById('checkBoxAll') !== null) {
                document.getElementById('checkBoxAll').checked = false;
            }
        }

        const combo = document.getElementById(this.state.comboSelected);
        if (this.state.comboSelected) {
            if (combo.contains(e.target) && combo !== e.target) {
                return;
            }
        }

        if (idComponente === this.state.comboSelected || idComponente === null) {
            this.setState({comboSelected: ''});
        } else if (nameComponente === 'divComboCheck') {
            this.setState({
                comboSelected: idComponente,
            });

            if (idComponente === COMBO_CHECK_FILIAL) {
                getFiliales(this.state.checkZonas, this.state.checkAreaVta).then((result) => {
                    if (result.data.estadoTrama === '1') {
                        this.setState({
                            filialesXAreaVtaXZona: result.data.filial
                                .map(row => ({
                                    id: row.codFilial,
                                    descripcion: row.nomFilial
                                })),
                        });
                    }
                });
            }
            if (idComponente === COMBO_CHECK_FAMILIA) {
                this.props.fetchFamiliaPorAreaVta(this.state.checkAreaVta);
            }
        }
    }

    handleInputChangeComboCheck(event, id, idComponente) {
        if (idComponente === COMBO_CHECK_A_VTA) {
            if (event.target.checked === true) {
                this.setState({checkAreaVta: [...this.state.checkAreaVta, id]});
            } else {
                this.setState({
                    checkAreaVta: this.state.checkAreaVta.filter(x => x !== id),
                });
            }
            this.setState({checkFamilia: []});
            document.querySelectorAll(`.${COMBO_CHECK_FAMILIA}`).forEach(combo => combo.checked = false);
            this.setState({checkFiliales: []});
            document.querySelectorAll(`.${COMBO_CHECK_FILIAL}`).forEach(combo => combo.checked = false);
        } else if (idComponente === COMBO_CHECK_FAMILIA) {
            if (event.target.checked === true) {
                this.setState({checkFamilia: [...this.state.checkFamilia, id]});
            } else {
                this.setState({
                    checkFamilia: this.state.checkFamilia.filter(x => x !== id),
                });
            }
        } else if (idComponente === COMBO_CHECK_FILIAL) {
            if (event.target.checked === true) {
                this.setState({checkFiliales: [...this.state.checkFiliales, id]});
            } else {
                this.setState({
                    checkFiliales: this.state.checkFiliales.filter(x => x !== id),
                });
            }
        } else if (idComponente === COMBO_CHECK_COMPANIA) {
            if (event.target.checked === true) {
                this.setState({checkCompanias: [...this.state.checkCompanias, id]});
            } else {
                this.setState({
                    checkCompanias: this.state.checkCompanias.filter(x => x !== id),
                });
            }
        } else if (idComponente === COMBO_CHECK_ZONA) {
            if (event.target.checked === true) {
                this.setState({checkZonas: [...this.state.checkZonas, id]});
            } else {
                this.setState({
                    checkZonas: this.state.checkZonas.filter(x => x !== id),
                });
            }
            this.setState({checkFiliales: []});
            document.querySelectorAll(`.${COMBO_CHECK_FILIAL}`).forEach(combo => combo.checked = false);
        } else if (idComponente === COMBO_CHECK_TIPOFICHA) {
            if (event.target.checked === true) {
                this.setState({checkTipoFicha: [...this.state.checkTipoFicha, id]});
            } else {
                this.setState({
                    checkTipoFicha: this.state.checkTipoFicha.filter(x => x !== id),
                });
            }
        } else if (idComponente === COMBO_CHECK_MONEDA) {
            if (event.target.checked === true) {
                this.setState({checkMoneda: [...this.state.checkMoneda, id]});
            } else {
                this.setState({
                    checkMoneda: this.state.checkMoneda.filter(x => x !== id),
                });
            }
        } else if (idComponente === COMBO_CHECK_TIPOPAGO) {
            if (event.target.checked === true) {
                this.setState({checkTipoPago: [...this.state.checkTipoPago, id]});
            } else {
                this.setState({
                    checkTipoPago: this.state.checkTipoPago.filter(x => x !== id),
                });
            }
        } else if (idComponente === COMBO_CHECK_MONEDACREDITO) {
            if (event.target.checked === true) {
                this.setState({checkMonedaCredito: [...this.state.checkMonedaCredito, id]});
            } else {
                this.setState({
                    checkMonedaCredito: this.state.checkMonedaCredito.filter(x => x !== id),
                });
            }
        } else if (idComponente === COMBO_CHECK_TIPOADQUISICION) {
            if (event.target.checked === true) {
                this.setState({checkTipoAdquisicion: [...this.state.checkTipoAdquisicion, id]});
            } else {
                this.setState({
                    checkTipoAdquisicion: this.state.checkTipoAdquisicion.filter(x => x !== id),
                });
            }
        } else if (idComponente === COMBO_CHECK_CLAUSULAS) {
            if (event.target.checked === true) {
                this.setState({checkClausulas: [...this.state.checkClausulas, id]});
            } else {
                this.setState({
                    checkClausulas: this.state.checkClausulas.filter(x => x !== id),
                });
            }
        }
    }

    cancelarModalMasFiltros() {
        this.cerrarModalMasFiltros();
    }

    selectFDVentaAll() {
        const entregasRows = [];
        if (document.getElementById('checkBoxAll').checked) {
            this.props.fichasVenta.fichaVentaResponse.forEach((fichaVenta) => {
                entregasRows.push(fichaVenta.numFichaVtaVeh);
            });
        }
        this.setState({fdvSelected: entregasRows});
    }

    porcentajes() {
        return (<div className='pageHead-kpis wrapper'>
            <div className='Stats'>
                <div className='squareStats'>
                    <p className='squareStats-number'>128</p>
                    <p className='squareStats-title'>N° Fichas creadas</p>
                </div>
                <div className='squareStats'>
                    <p className='squareStats-number'>100</p>
                    <p className='squareStats-title'>N° Fichas cerradas</p>
                </div>
                <div className='squareStats'>
                    <p className='squareStats-number'>11</p>
                    <p className='squareStats-title'>N° Fichas anuladas</p>
                </div>
            </div>
        </div>);
    }

    handleClearFilter() {
        document.querySelectorAll('.dropdown.dropdown-multi').forEach(combo => combo.classList.remove('open'));
        document.querySelectorAll('input[name=comboCheck]:not(.COMBO_CHECK_CLAUSULAS)').forEach(combo => combo.checked = false);
        this.setState({

            fdvSelected: [],
            comboOpen: false,

            estado: '[C,V,E,I]',
            startDateInicio: '',
            startDateFinal: '',
            searchOption: 'nfdv',
            comboSelected: '',
            checkAreaVta: [],
            checkFiliales: [],
            checkFamilia: [],
            checkCompanias: [],
            checkZonas: [],
            checkTipoFicha: [],
            checkMoneda: [],
            checkTipoPago: [],
            checkMonedaCredito: [],
            checkTipoAdquisicion: [],
            numeroInput: '',
            searchOptionFechas: 'fcreacion',
            nomClienteInput: '',
            baumausterInput: '',
            clausulaCompraInput: '',
            configModelVehInput: '',
            filialesXAreaVtaXZona: [],
            vendedorId: '',
            vendedorName: '',

            codClienteFiltro: '',
            nomClienteFiltro: '',
            codAsesorFiltro: '',
            nomAsesorFiltro: '',
            codigoBaumusterFiltro: '',
            nombreBaumusterFiltro: '',
            codigoConfiguracionFiltro: '',
            nombreConfiguracionFiltro: '',
            codigoSKUFiltro: '',
            codigoClausulaFiltro: this.state.codigoClausulaFiltro,
            checkClausulas: this.state.checkClausulas,
            clausulas: this.state.clausulas
        });
        this.setState({muestraLoad: 'block', nInicio: PAG_1, nroPag: PAG_1});
        document.getElementById('startDateInicioInput').value = '';
        document.getElementById('startDateFinalInput').value = '';

        this.datepickerInicio.setState({inputValue: ''});
        this.datepickerFinal.setState({inputValue: ''});

        if (document.getElementById('checkBoxAll') !== null) {
            document.getElementById('checkBoxAll').checked = false;
        }
        
        this.props.loadFichasVenta();
        this.props.fetchFichasVenta('[C,V,E,I]', PAG_1, CANT_X_PAG, 'nfdv', '', 'fcreacion',
            '', '','','','','','','','','','',this.state.checkClausulas,'','',''
            /*this.state.checkAreaVta, this.state.checkFamilia,
            this.state.checkFiliales, this.state.checkCompanias,
            this.state.codClienteFiltro, this.state.codAsesorFiltro,
            this.state.codigoBaumusterFiltro, this.state.codigoConfiguracionFiltro,
            this.state.codigoSKUFiltro, this.state.codigoClausulaFiltro,
            this.state.checkMoneda,this.state.checkZonas,this.state.checkTipoAdquisicion*/
            /*this.state.checkTipoFicha,
            this.state.baumausterInput,
           this.state.checkTipoPago, this.state.checkMonedaCredito,
           this.state.clausulaCompraInput, this.state.configModelVehInput,*/
        )
            .then((result) => {
                console.log(result);
                if (result.payload.data.estadoTrama === '1') {
                    this.initPaginacion(result.payload.data.totalRegistros,
                        result.payload.data.cantidadPaginas);
                } else if (result.payload.data.estadoTrama === '0') {
                    this.setState({
                        muestraLoad: 'none',
                        iconAlert: 'ion-close-circled',
                        colorBackground: '#F56669',
                        mensajeAlert: result.payload.data.mensaje
                    });
                    IndexFichaVenta.hideMessage();
                } else if (result.payload.data.estadoTrama === '-1') {
                    this.setState({
                        muestraLoad: 'none',
                        iconAlert: 'ion-close-circled',
                        colorBackground: '#F56669',
                        mensajeAlert: `¡Error interno del servidor:${result.payload.data.mensaje}!`
                    });
                    IndexFichaVenta.hideMessage();
                } else {
                    this.setState({
                        muestraLoad: 'none',
                        iconAlert: 'ion-close-circled',
                        colorBackground: '#F56669',
                        mensajeAlert: `¡Error interno del servidor:${result.payload.data.estadoTrama}!`
                    });
                    IndexFichaVenta.hideMessage();
                }
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    muestraLoad: 'none',
                    iconAlert: 'ion-close-circled',
                    colorBackground: '#F56669',
                    mensajeAlert: '¡Error interno del servidor!'
                });
                IndexFichaVenta.hideMessage();
            });
    }

    clickDescargarExcel() {
        this.loading('block');
        const validacion = this.validacionGrilla();
        this.props.fetchReporteConsultaFichaVenta(this.state.estado, 1, 50,
            this.state.searchOption, this.state.numeroInput,
            this.state.searchOptionFechas, validacion.dateInicio, validacion.dateFinal,
            this.state.checkAreaVta, this.state.checkFamilia,
            this.state.checkFiliales, this.state.checkCompanias,
            this.state.vendedorId, this.state.nomClienteInput,
            this.state.checkZonas, this.state.checkTipoFicha,
            this.state.checkMoneda, this.state.baumausterInput,
            this.state.checkTipoPago, this.state.checkMonedaCredito,
            this.state.clausulaCompraInput, this.state.configModelVehInput,
            this.state.checkTipoAdquisicion
        ).then(entry => {
            this.descargarPDF(entry.payload.data.reportePdf);
            this.loading('');
        }).catch((error) => {
            this.loading('');
            console.log(error);
        });

    }
    /*Incio Req. 92349 ebarboza 18 06 2021 */
    openAlert = (data) => {
        if (data.estadoTrama === '0') {
          this.setState({ alertErrorMessage: data.mensaje });
          this.showAlert('alertErrorOpen');
        } else if (data.estadoTrama === '1') {
          this.setState({ alertSuccessMessage: data.mensaje });
          this.showAlert('alertSuccessOpen');
        } else {
          this.setState({ alertErrorMessage: `Hubo un error con el servicio ${data.estadoTrama}` });
          this.showAlert('alertErrorOpen');
        }
      }
      showAlert = (alertType) => {
        this.setState({ [alertType]: true });
        setTimeout(() => this.setState({ [alertType]: false }), 5000);
      }
      closeAlertSuccess = () => this.setState({ alertSuccessOpen: false });
      closeAlertSuccess = () => this.setState({ alertErrorOpen: false });
    clickDescargarExcelBonos() {
        this.loading('block');
        const validacion = this.validacionGrilla();
        this.props.fetchReporteConsultaFichaVentaBonos(this.state.estado, 1, 50,
            this.state.searchOption, this.state.numeroInput,
            this.state.searchOptionFechas, validacion.dateInicio, validacion.dateFinal,
            this.state.checkAreaVta, this.state.checkFamilia,
            this.state.checkFiliales, this.state.checkCompanias,
            this.state.vendedorId, this.state.nomClienteInput,
            this.state.checkZonas, this.state.checkTipoFicha,
            this.state.checkMoneda, this.state.baumausterInput,
            this.state.checkTipoPago, this.state.checkMonedaCredito,
            this.state.clausulaCompraInput, this.state.configModelVehInput,
            this.state.checkTipoAdquisicion
        ).then(entry => {

            if(entry.payload.data.error){
                entry.payload.data.estadoTrama = "0"
                this.openAlert(entry.payload.data)
                
            }else{
                entry.payload.data.estadoTrama = "1"
                this.openAlert(entry.payload.data)
                this.descargarPDF(entry.payload.data.reportePdf);
            }
            this.loading('');
        }).catch((error) => {
            this.loading('');
            console.log(error);
        });

    }
    /*Fin Req. 92349 ebarboza 18 06 2021 */

    renderFichasVenta() {
        return !this.props.fichasVenta ?
            [] : (this.props.fichasVenta.fichaVentaResponse.length > 0 ? (
                        this.props.fichasVenta.fichaVentaResponse.map((fichaVenta, i) => (
                            <tr key={i}>
                                <td>
                                    <div className='checkbox checkbox-inline'>
                                        <label>
                                            <input type='checkbox'
                                                   checked={this.state.fdvSelected.indexOf(fichaVenta.numFichaVtaVeh) >= 0}/>
                                            <div className='checkbox-skin'
                                                 onClick={() => this.selectFDV(fichaVenta.numFichaVtaVeh)}/>
                                        </label>
                                    </div>
                                </td>
                                <td>
                                    <ErrorUIComponent>
                                        <Link target="_blank" to={`/fichas-venta/${fichaVenta.numFichaVtaVeh}`}>
                                            {fichaVenta.numFichaVtaVeh}
                                        </Link>
                                    </ErrorUIComponent>

                                </td>
                                <td>{fichaVenta.desTipoFichaVtaVeh}</td>
                                <td>{moment(fichaVenta.fecFichaVtaVeh).format('DD/MM/YYYY')}</td>
                                <td>{IndexFichaVenta.pillFormatter(fichaVenta.desEstadoFichaVta)}</td>
                                <td>{fichaVenta.desTipoPago}</td>
                                <td>{fichaVenta.nomPerso}</td>
                                <td>{fichaVenta.clausCompDes}</td>
                                <td>{fichaVenta.nroProf}</td>
                                <td>{fichaVenta.pedAsig}</td>
                                <td>{fichaVenta.pedFact}</td>
                                <td>{fichaVenta.pedEntr}</td>
                            </tr>)))
                    : (
                        <tr>
                            <td colSpan='12'><p style={{textAling: 'center'}}> No existe registros para la busqueda
                                !!</p></td>
                        </tr>
                    )
            );
    }

    functionValidacion() {

        if (this.state.modalOpen === 'nueva-fdv' && this.state.muestraLoad === 'none') {
            return (
                <div>

                    {

                        <NuevaFichaVenta
                            querys={qs.parse(this.props.location.search)}
                            closeModal={this.closeModal}
                        />
                    }
                </div>
            )
        }

    }


    obtieneClientes() {
        let cadena = this.state.nombreClienteInput;
        let ruc = this.state.rucClienteInput;
        let dni = this.state.dniClienteInput;
        let codCliente = this.state.codClienteInput;
        this.setState({muestraLoad2: 'block'})
        this.props.fetchObtenerClientes(cadena, ruc, dni, codCliente, PAG_1, CANT_X_PAG)
            .then(data => {
                this.setState({clienteResponse: data.payload.data.data})
                this.setState({muestraLoad2: 'none'})
                this.initPaginacionCliente(data.payload.data.cantidad,
                    data.payload.data.numerodePaginas);
            });
        /*this.setState({
            nombreClienteInput: '',
            rucClienteInput: '',
            dniClienteInput: ''
        })*/
    }

    getClienteById(value, name){
        this.setState({muestraLoad2: 'block'})
        if(name === 'cadena'){
            this.props.fetchObtenerClientes(value,'','', '', PAG_1, CANT_X_PAG)
                .then(data => {
                    this.setState({clienteResponse: data.payload.data.data})
                    this.setState({muestraLoad2: 'none'})
                    this.initPaginacionCliente(data.payload.data.cantidad,
                        data.payload.data.numerodePaginas);
                });
        } else if(name === 'ruc'){
            this.props.fetchObtenerClientes('',value,'', '', PAG_1, CANT_X_PAG)
                .then(data => {
                    this.setState({clienteResponse: data.payload.data.data})
                    this.setState({muestraLoad2: 'none'})
                    this.initPaginacionCliente(data.payload.data.cantidad,
                        data.payload.data.numerodePaginas);
                });
        } else if(name === 'dni'){
            this.props.fetchObtenerClientes('','',value, '', PAG_1, CANT_X_PAG)
                .then(data => {
                    this.setState({clienteResponse: data.payload.data.data})
                    this.setState({muestraLoad2: 'none'})
                    this.initPaginacionCliente(data.payload.data.cantidad,
                        data.payload.data.numerodePaginas);
                });
        } else {
            if(value.length > 0){
                this.props.fetchObtenerClientes('','','', value, PAG_1, CANT_X_PAG)
                    .then(data => {
                        if(data.payload.data.cantidad < 1){
                            this.setState({clienteExiste: false});
                            this.setState({codClienteFiltro: ''});
                            this.setState({nomClienteFiltro: ''});
                            this.setState({muestraLoad2: 'none'})
                            setTimeout(() => {
                                this.setState({clienteExiste: true})
                            }, 6000)
                        } else {
                            this.setState({codClienteFiltro: data.payload.data.data[0]['codigo']});
                            this.setState({nomClienteFiltro: data.payload.data.data[0]['nombre'].trim()});
                            this.setState({muestraLoad2: 'none'})
                            this.setState({clienteExiste: true})
                        }
                    })
            } else {
                this.setState({muestraLoad2: 'block'})
                setTimeout(() => {
                    this.setState({muestraLoad2: 'none'})
                    this.setState({clienteExiste: false});
                }, 500)
                setTimeout(() => {
                    this.setState({clienteExiste: true})
                }, 6000)
            }


        }
    }

    limpiaFiltrosCliente(){
        this.setState({
            nombreClienteInput: '',
            dniClienteInput: '',
            rucClienteInput: '',
            clienteResponse: [],
            codClienteFiltro: '',
            nomClienteFiltro: '',
            cantidadPaginasClientes: 0,
            totalClientesRegistros: 0,
            nroPagCliente: 0,
            nInicioCliente: 0,
            nFinCliente: 0,
        })
    }

    closeAlertCliente = () => this.setState({ clienteExiste: true });

    obtieneAsesores(){
        let nombre = this.state.nombreAsesorInput;
        let cod = this.state.codigoAsesorInput;
        this.setState({muestraLoad2: 'block'});
        this.props.fetchobtenerAsesor(cod, nombre, PAG_1, CANT_X_PAG)
            .then(data => {
                this.setState({asesorResponse: data.payload.data.listVendedor})
                this.setState({muestraLoad2: 'none'});
                this.initPaginacionAsesor(data.payload.data.cantidad,
                    data.payload.data.numerodePaginas);
            });
        /*this.setState({
            codigoAsesorInput: ''
        })*/
    }

    getAsesorById(value, name){
        this.setState({muestraLoad2: 'block'});
        if(name === 'nombre'){
            this.props.fetchobtenerAsesor('', value, PAG_1, CANT_X_PAG)
                .then(data => {
                    this.setState({asesorResponse: data.payload.data.listVendedor})
                    this.setState({muestraLoad2: 'none'});
                });
        } else if (name === 'codigo'){
            this.props.fetchobtenerAsesor(value, '', PAG_1, CANT_X_PAG)
                .then(data => {
                    this.setState({asesorResponse: data.payload.data.listVendedor})
                    this.setState({muestraLoad2: 'none'});
                });
        } else {
            if(value.length > 0){
                this.props.fetchobtenerAsesor(value, '', PAG_1, CANT_X_PAG)
                    .then(data => {
                        if(data.payload.data.cantidad < 1){
                            this.setState({asesorExiste: false});
                            this.setState({codAsesorFiltro: ''});
                            this.setState({nomAsesorFiltro: ''})
                            this.setState({muestraLoad2: 'none'})
                            setTimeout(() => {
                                this.setState({asesorExiste: true})
                            }, 6000)
                        } else {
                            this.setState({codAsesorFiltro: data.payload.data.listVendedor[0]['codVendedor']});
                            this.setState({nomAsesorFiltro: data.payload.data.listVendedor[0]['nombre']})
                            this.setState({muestraLoad2: 'none'})
                            this.setState({asesorExiste: true})
                        }
                    });
            } else {
                this.setState({muestraLoad2: 'block'})
                setTimeout(() => {
                    this.setState({muestraLoad2: 'none'})
                    this.setState({asesorExiste: false});
                }, 500)
                setTimeout(() => {
                    this.setState({asesorExiste: true})
                }, 6000)
            }


        }

    }

    limpiaFiltrosAsesor(){
        this.setState({
            asesorResponse: [],
            codigoAsesorInput: '',
            nombreAsesorInput: '',
            codAsesorFiltro: '',
            nomAsesorFiltro: '',
            cantidadPaginasAsesores: 0,
            totalAsesoresRegistros: 0,
            nroPagAsesor: 0,
            nInicioAsesor: 0,
            nFinAsesor: 0,
        })
    }

    obtieneBaumuster(){
        let cod = this.state.codigoBaumusterInput;
        let nombre = this.state.nombreBaumusterInput;
        this.setState({muestraLoad2: 'block'});
        this.props.fetchObtenerModelo(cod, nombre, PAG_1, CANT_X_PAG)
            .then(data => {
                this.setState({baumusterResponse: data.payload.data.listModelo})
                this.setState({muestraLoad2: 'none'});
                this.initPaginacionBaumuster(data.payload.data.cantidad,
                    data.payload.data.numerodePaginas);
            });
    }

    getBaumusterById(value, name){
        this.setState({muestraLoad2: 'block'});
        if(name === 'nombre'){
            this.props.fetchObtenerModelo('', value, PAG_1, CANT_X_PAG)
                .then(data => {
                    this.setState({baumusterResponse: data.payload.data.listModelo})
                    this.setState({muestraLoad2: 'none'});
                    this.initPaginacionBaumuster(data.payload.data.cantidad,
                        data.payload.data.numerodePaginas);
                });
        } else if(name === 'codigo') {
            this.props.fetchObtenerModelo(value, '', PAG_1, CANT_X_PAG)
                .then(data => {
                    this.setState({baumusterResponse: data.payload.data.listModelo})
                    this.setState({muestraLoad2: 'none'});
                    this.initPaginacionBaumuster(data.payload.data.cantidad,
                        data.payload.data.numerodePaginas);
                });
        } else {
            if(value.length > 0){
                this.props.fetchObtenerModelo(value, '', PAG_1, CANT_X_PAG)
                    .then(data => {
                        if(data.payload.data.cantidad < 1){
                            this.setState({baumusterExiste: false});
                            this.setState({codigoBaumusterFiltro: ''});
                            this.setState({nombreBaumusterFiltro: ''})
                            this.setState({muestraLoad2: 'none'})
                            setTimeout(() => {
                                this.setState({baumusterExiste: true})
                            }, 6000)
                        } else {
                            this.setState({codigoBaumusterFiltro: data.payload.data.listModelo[0]['id']});
                            this.setState({nombreBaumusterFiltro: data.payload.data.listModelo[0]['nombre']});
                            this.setState({muestraLoad2: 'none'});
                            this.setState({baumusterExiste: true})
                        }
                    })
            } else {
                this.setState({muestraLoad2: 'block'})
                setTimeout(() => {
                    this.setState({muestraLoad2: 'none'})
                    this.setState({baumusterExiste: false});
                }, 500)
                setTimeout(() => {
                    this.setState({baumusterExiste: true})
                }, 6000)
            }
        }
    }

    limpiaFiltrosBaumuster(){
        this.setState({
            baumusterResponse:[],
            codigoBaumusterInput: '',
            nombreBaumusterInput: '',
            codigoBaumusterFiltro: '',
            nombreBaumusterFiltro: '',
            cantidadPaginasBaumuster: 0,
            totalBaumusterRegistros: 0,
            nroPagBaumuster: 0,
            nInicioBaumuster: 0,
            nFinBaumuster: 0,
        })
    }

    obtieneConfiguracion(){
        let nombre = this.state.nombreConfiguracionInput;
        let sku = this.state.codigoSKUInput;
        this.setState({muestraLoad2: 'block'});
        this.props.fetchObtenerConfiguracion(nombre, sku, PAG_1, CANT_X_PAG)
            .then(data => {
                console.log(data)
                this.setState({configuracionResponse: data.payload.data.busqueda})
                this.setState({muestraLoad2: 'none'});
                this.initPaginacionConfig(data.payload.data.totalRegistros,
                    data.payload.data.totalPaginacion);
            });
    }

    getConfiguracionById(value, name){
        this.setState({muestraLoad2: 'block'});
        if(name === 'nombre'){
            this.props.fetchObtenerConfiguracion(value, '', PAG_1, CANT_X_PAG)
                .then(data => {
                    this.setState({configuracionResponse: data.payload.data.busqueda})
                    this.setState({muestraLoad2: 'none'});
                    this.initPaginacionBaumuster(data.payload.data.totalRegistros,
                        data.payload.data.totalPaginacion);
                });
        } else if(name === 'codigo') {
            this.props.fetchObtenerConfiguracion('', value, PAG_1, CANT_X_PAG)
                .then(data => {
                    this.setState({configuracionResponse: data.payload.data.busqueda})
                    this.setState({muestraLoad2: 'none'});
                    this.initPaginacionBaumuster(data.payload.data.totalRegistros,
                        data.payload.data.totalPaginacion);
                });
        } else {
            if(value.length > 0){
                this.props.fetchObtenerConfiguracion('', value, PAG_1, CANT_X_PAG)
                    .then(data => {
                        if(data.payload.data.totalPaginacion < 1){
                            this.setState({configuracionExiste: false});
                            this.setState({codigoConfiguracionFiltro: ''});
                            this.setState({nombreConfiguracionFiltro: ''})
                            this.setState({muestraLoad2: 'none'})
                            setTimeout(() => {
                                this.setState({configuracionExiste: true})
                            }, 6000)
                        } else {
                            this.setState({codigoConfiguracionFiltro: data.payload.data.busqueda[0]['codConfigVeh']});
                            this.setState({nombreConfiguracionFiltro: data.payload.data.busqueda[0]['desConfigVeh']});
                            this.setState({muestraLoad2: 'none'});
                            this.setState({configuracionExiste: true})
                        }
                    })
            } else {
                this.setState({muestraLoad2: 'block'})
                setTimeout(() => {
                    this.setState({muestraLoad2: 'none'})
                    this.setState({configuracionExiste: false});
                }, 500)
                setTimeout(() => {
                    this.setState({configuracionExiste: true})
                }, 6000)
            }
        }
    }

    limpiaFiltrosConfiguracion(){
        this.setState({
            configuracionResponse:[],
            codigoSKUInput: '',
            nombreConfiguracionInput: '',
            codigoConfiguracionFiltro: '',
            nombreConfiguracionFiltro: '',
            cantidadPaginasConfi: 0,
            totalConfiguracionRegistros: 0,
            nroPagConfig: 0,
            nInicioConfig: 0,
            nFinConfig: 0,
        })
    }

    fnClienteSelected = (item) => {
        this.setState({codClienteFiltro: item.codigo});
        this.setState({nomClienteFiltro: item.nombre});
        this.setState({isOpenCliente: 'none'});
    };

    fnAsesorSelected = (item) => {
        this.setState({codAsesorFiltro: item.codVendedor});
        this.setState({nomAsesorFiltro: item.nombre});
        this.setState({isOpenAsesor: 'none'});
    };

    fnBaumusterSelected = (item) => {
        this.setState({codigoBaumusterFiltro: item.id});
        this.setState({nombreBaumusterFiltro: item.nombre});
        this.setState({isOpenBaumuster: 'none'});
    };

    fnConfiguracionSelected = (item) => {
        this.setState({codigoConfiguracionFiltro: item.codConfigVeh});
        this.setState({nombreConfiguracionFiltro: item.desConfigVeh});
        this.setState({codigoSKUFiltro: item.skuSap})
        this.setState({isOpenConfiguracion: 'none'});
    }

    render() {
        return (
            <ErrorUIComponent>
                <div>
                    <div className='pageHead'>
                        <div
                            className={`alert alert-actions ${this.state.fdvSelected.length ? 'js-flex-open' : 'js-hide'}`}
                            id='fdv-tableActions'>
                            <p>
                                <span className='bold'>{this.state.fdvSelected.length}&nbsp;</span>
                                <span
                                    className='regular'>{this.state.fdvSelected.length === 1 ? 'Elemento seleccionado' : 'Elementos seleccionados'}</span>
                            </p>
                            <div className={`btn-drop ${this.state.comboOpen ? 'open' : ''}`} role='group'>
                                <button
                                    className='btn dropdown-toggle btn-blue'
                                    onClick={() => this.setState({comboOpen: !this.state.comboOpen})}
                                >
                                    Cambiar estado
                                    <i className='ion-arrow-down-b ml-2'/>
                                </button>
                                <ul className='dropdown-menu'>
                                    <li>
                                        <a onClick={() => this.updateFichaVentaStates('I')}>
                                            <i className='ion-record c-red'/>
                                            <span>Anulado</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a onClick={() => this.updateFichaVentaStates('E')}>
                                            <i className='ion-record c-gray-1'/>
                                            <span>Cerrado</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a onClick={() => this.updateFichaVentaStates('V')}>
                                            <i className='ion-record c-green'/>
                                            <span>Vigente</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <Mainrow
                            clickDescargarExcel={this.clickDescargarExcel}
                            clickDescargarExcelBonos={this.clickDescargarExcelBonos}/*Req. 92349 ebarboza 18 06 2021*/
                            openModal={this.openModal}
                            closeModal={this.closeModal}
                        />
                        <div>
                            <div className='pageHead-rowContainer'>
                                {this.porcentajes()}
                            </div>
                            <div className='pageHead-rowContainer'>
                                <div className='pageHead-filters wrapper'>
                                    <div className='pageHead-filters-search'>
                                        <div className='fSearch'>
                                            <div className='fSearch-filter form-control'>
                                                <select value={this.state.searchOption}
                                                        onChange={this.changeSearchOption}>
                                                    <option value='nfdv'>N° FDV</option>
                                                    <option value='nproforma'>N° Proforma</option>
                                                    <option value='npedido'>N° Pedido</option>
                                                </select>
                                            </div>
                                            <input
                                                type='text'
                                                className='fSearch-search form-control checkDeGrillaEnterCerrar'
                                                value={this.state.numeroInput}
                                                onChange={this.onChangeNumeroInput}
                                                onKeyPress={(e) => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault();
                                                        this.searchNumero();
                                                    }
                                                }}
                                            />
                                            <button
                                                className='btn btn-dark fSearch-go checkDeGrillaCerrar'
                                                type='button'
                                                title='Filtrar'
                                                onClick={() => this.searchNumero()}
                                            ><i className='ion-android-arrow-forward'/></button>
                                        </div>
                                    </div>
                                    <div className='pageHead-filters-drops'>
                                        <div className='fSearch'>
                                            <div className='fSearch-filter form-control'><i className='ion-calendar'/>
                                                <select
                                                    value={this.state.searchOptionFechas}
                                                    onChange={this.changeSearchOptionFechas}
                                                >
                                                    <option value='fcreacion'>F° Creación</option>
                                                    <option value='fcierre'>F° Cierre</option>
                                                </select>
                                            </div>
                                            <DatePicker
                                                selected={this.state.startDateInicio ? this.state.startDateInicio : moment(moment().subtract(1, 'month'))}
                                                className='form-control fSearch-search date-picker ng-pristine ng-valid ng-isolate-scope ng-touched checkDeGrillaEnterCerrar'
                                                dateFormat='DD/MM/YYYY'
                                                locale='es'
                                                onChange={this.handleChangeInicio}
                                                onKeyDown={(e) => {
                                                    if (e.keyCode === 13) {
                                                        e.preventDefault();
                                                        this.searchFechas();
                                                    }
                                                }}
                                                id='startDateInicioInput'
                                                ref={(datepicker) => {
                                                    this.datepickerInicio = datepicker;
                                                }}
                                            />
                                            <DatePicker
                                                selected={this.state.startDateFinal ? this.state.startDateFinal : moment()}
                                                className='form-control fSearch-search date-picker ng-pristine ng-valid ng-isolate-scope ng-touched checkDeGrillaEnterCerrar'
                                                dateFormat='DD/MM/YYYY'
                                                locale='es'
                                                onChange={this.handleChangeFinal}
                                                onKeyDown={(e) => {
                                                    if (e.keyCode === 13) {
                                                        e.preventDefault();
                                                        this.searchFechas();
                                                    }
                                                }}
                                                id='startDateFinalInput'
                                                ref={(datepicker) => {
                                                    this.datepickerFinal = datepicker;
                                                }}
                                            />
                                            <button
                                                className='btn btn-dark fSearch-go checkDeGrillaCerrar'
                                                onClick={this.searchFechas}
                                                title='Filtrar'
                                            ><i className='ion-android-arrow-forward'/></button>
                                        </div>
                                        <ComboCheck
                                            name='Area de Venta'
                                            idComponente={COMBO_CHECK_A_VTA}
                                            onClickFiltrar={this.handleClickComboCheckFiltrar}
                                            onClickCheck={this.handleInputChangeComboCheck}
                                            lista={!this.props.areasVenta ? [] : this.props.areasVenta}
                                            id='id'
                                            nombre='nombre'
                                            total={this.state.checkAreaVta.length}
                                            withButton
                                        />
                                        <ComboCheck
                                            name='Familia'
                                            idComponente={COMBO_CHECK_FAMILIA}
                                            onClickFiltrar={this.handleClickComboCheckFiltrar}
                                            onClickCheck={this.handleInputChangeComboCheck}
                                            lista={!this.props.familias ? [] : this.props.familias}
                                            id='codFamVeh'
                                            nombre='desFamVeh'
                                            total={this.state.checkFamilia.length}
                                            withButton
                                        />
                                        <ComboCheck
                                            name='Filial'
                                            idComponente={COMBO_CHECK_FILIAL}
                                            onClickFiltrar={this.handleClickComboCheckFiltrar}
                                            onClickCheck={this.handleInputChangeComboCheck}
                                            lista={!this.state.filialesXAreaVtaXZona ?
                                                [] : this.state.filialesXAreaVtaXZona}
                                            id='id'
                                            nombre='descripcion'
                                            total={this.state.checkFiliales.length}
                                            withButton
                                        />
                                        <button className='btn btn-default pageHead-filters-extra checkDeGrillaCerrar'
                                                title='Más filtros' onClick={this.abrirModalMasFiltros}>Más filtros
                                        </button>
                                        <button className='btn pageHead-tableConf-clean checkDeGrillaCerrar'
                                                title='Limpiar filtros' onClick={() => this.handleClearFilter()}><i
                                            className='ion-funnel'/></button>
                                    </div>
                                </div>
                            </div>

                            <div className='pageHead-rowContainer'>
                                <div className='pageHead-tableConf wrapper'>
                                    <div className='pageHead-tableConf-tabs'>
                                        <ul className='tabs' role='tablist'>
                                            <li className={`tabs-item ${this.state.estado === '[C,V,E,I]' ? 'active' : null}`}>
                                                <a className='tabs-item-link checkDeGrillaCerrar'
                                                   onClick={() => this.handleClick('[C,V,E,I]')}>Todas</a>
                                            </li>
                                            <li className={`tabs-item ${this.state.estado === 'C' ? 'active' : null}`}>
                                                <a className='tabs-item-link checkDeGrillaCerrar'
                                                   onClick={() => this.handleClick('C')}>Creación</a>
                                            </li>
                                            <li className={`tabs-item ${this.state.estado === 'V' ? 'active' : null}`}>
                                                <a className='tabs-item-link checkDeGrillaCerrar'
                                                   onClick={() => this.handleClick('V')}>Vigencia</a>
                                            </li>
                                            <li className={`tabs-item ${this.state.estado === 'E' ? 'active' : null}`}>
                                                <a className='tabs-item-link checkDeGrillaCerrar'
                                                   onClick={() => this.handleClick('E')}>Cerrado</a>
                                            </li>
                                            <li className={`tabs-item ${this.state.estado === 'I' ? 'active' : null}`}>
                                                <a className='tabs-item-link checkDeGrillaCerrar'
                                                   onClick={() => this.handleClick('I')}>Anulado</a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className='pageHead-tableConf-pagCols'>
                                        <nav className='pag'>
                                            <p className='pag-label'>
                                                <span>{this.state.nInicio}</span><span> -</span><span> {this.state.nFin}</span><span> de</span><span> {this.state.totalRegistros}</span>
                                            </p>
                                            <div className='pag-arrows'>
                                                <a className='btn btn-default pag-link checkDeGrillaCerrar'
                                                   title='Anterior' onClick={this.atras}><i
                                                    className='ion-chevron-left'/></a>
                                                <a className='btn btn-default pag-link checkDeGrillaCerrar'
                                                   title='Siguiente' onClick={this.siguiente}><i
                                                    className='ion-chevron-right'/></a>
                                            </div>
                                        </nav>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className='wrapper tableFdv'>
                        <div className='tableWrapper'>
                            <table className='table table-hover' style={{marginBottom: '100px'}}>
                                <thead className='table-head'>
                                <tr>
                                    <th>
                                        <div className='checkbox checkbox-inline'>
                                            <label>
                                                <input type='checkbox' id={'checkBoxAll'}
                                                       onClick={() => this.selectFDVentaAll()}/>
                                                <div className='checkbox-skin'/>
                                            </label>
                                        </div>
                                    </th>
                                    <th>Nº FDV</th>
                                    <th>TIPO</th>
                                    <th>FECHA</th>
                                    <th>ESTADO</th>
                                    <th>PAGO</th>
                                    <th>CLIENTE</th>
                                    <th>CLAUS. COMPRA</th>
                                    <th>#PROFORM. REL.</th>
                                    <th>#PEDIDOS REL.</th>
                                    <th>#SOLICITUDES FACT. REL.</th>
                                    <th>#PEDIDOS ENTREGADOS</th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.renderFichasVenta()}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className='modal extraFilter' role='dialog' data-backdrop='static'
                         style={{zIndex: '2000', display: this.state.muestraLoad}}>
                        <div className='modal-dialog modal-sm' role='document'>
                            <FadeLoader color={'#F8A14A'} loading/>
                        </div>
                    </div>
                    <div className='modal extraFilter' id='moreFilters' role='dialog' data-backdrop='static'
                         style={{display: this.state.muestraModalMasFiltros}}>
                        {/*<div className='modal-dialog modal-sm modal-pullRight' role='document'>*/}
                        <div className='modal-dialog' role='document'>
                            <button className='btn btn-sm btn-blue modal-close' data-dismiss='modal'
                                    onClick={this.cerrarModalMasFiltros}>Cerrar ventana
                            </button>
                            <div className='modal-content'>
                                <div className='modal-body'>
                                    <h2 className='modal-title'>Más filtros</h2>
                                    {/*REQ-86298*/
                                        <div className='row'>
                                            <div className='col-md-12'>
                                                <label className='control-label'>Cliente</label>
                                                <div className='row'>
                                                    <div className='col-md-5' style={{width: '9em'}}>
                                                        <input className='form-control'
                                                               value={this.state.codClienteFiltro}
                                                               onChange={(e) => {
                                                                   this.setState({codClienteFiltro: e.target.value});
                                                               }}
                                                               placeholder='Cod.'
                                                               onKeyDown={(e) => {
                                                                   if (e.keyCode === 13) {
                                                                       e.preventDefault();
                                                                       this.getClienteById(this.state.codClienteFiltro,'');
                                                                   } else if (e.keyCode === 8 || e.keyCode === 46){
                                                                       e.preventDefault();
                                                                       this.limpiaFiltrosCliente();
                                                                   }
                                                               }}
                                                               onBlur={() => {
                                                                   if(this.state.codClienteFiltro !== null && this.state.codClienteFiltro !== " " && this.state.codClienteFiltro !== ""){
                                                                       this.getClienteById(this.state.codClienteFiltro,'');
                                                                   }
                                                               }}/>
                                                    </div>
                                                    <div className='input-group col-md-7' style={{width: '32.6em'}}>
                                                        <input className='form-control'
                                                               value={this.state.nomClienteFiltro}
                                                               onChange={(e) => {
                                                                   this.setState({codClienteFiltro: e.target.value});
                                                               }}
                                                               placeholder='Nombre' readOnly={'readOnly'}/>
                                                        <span className='input-group-btn'>
                                          <button type='button' className='btn btn'
                                                  onClick={this.openModalCliente}><span
                                              className='ion-search'/></button>
                                      </span>
                                                    </div>
                                                    {
                                                        this.state.clienteExiste === false &&
                                                        <Alert type='alert-warning alertModal' icon='ion-alert-circled'>
                                                            <p>El Cliente no existe</p>
                                                        </Alert>
                                                    }
                                                </div>
                                            </div>
                                            <div className='col-md-12'>
                                                <div className='form-group'>
                                                    <label className='control-label'>Asesor Comercial</label>
                                                    <div className='row'>
                                                        <div className='col-md-5' style={{width: '9em'}}>
                                                            <input className='form-control'
                                                                   value={this.state.codAsesorFiltro}
                                                                   onChange={(e) => {
                                                                       this.setState({codAsesorFiltro: e.target.value});
                                                                   }}
                                                                   placeholder='Cod.'
                                                                   onKeyDown={(e) => {
                                                                       if (e.keyCode === 13) {
                                                                           e.preventDefault();
                                                                           this.getAsesorById(this.state.codAsesorFiltro);
                                                                       } else if (e.keyCode === 8 || e.keyCode === 46){
                                                                           e.preventDefault();
                                                                           this.limpiaFiltrosAsesor();
                                                                       }
                                                                   }}
                                                                   onBlur={() => {
                                                                       if(this.state.codAsesorFiltro !== null && this.state.codAsesorFiltro !== " " && this.state.codAsesorFiltro !== ""){
                                                                           this.getAsesorById(this.state.codAsesorFiltro,'');
                                                                       }
                                                                   }}/>
                                                        </div>
                                                        <div className='input-group col-md-7' style={{width: '32.6em'}}>
                                                            <input className='form-control'
                                                                   value={this.state.nomAsesorFiltro}
                                                                   onChange={(e) => {
                                                                       this.setState({nomAsesorFiltro: e.target.value});
                                                                   }}
                                                                   placeholder='Nombre' readOnly={'readOnly'}/>
                                                            <span className='input-group-btn'>
                                  <button type='button' className='btn btn' onClick={this.openModalAsesor}><span className='ion-search'/></button>
                                </span>
                                                        </div>
                                                        {
                                                            this.state.asesorExiste === false &&
                                                            <Alert type='alert-warning alertModal' icon='ion-alert-circled'>
                                                                <p>El Asesor no existe</p>
                                                            </Alert>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-md-12'>
                                                <div className='form-group'>
                                                    <label className='control-label'>Baumuster</label>
                                                    <div className='row'>
                                                        <div className='col-md-5' style={{width: '9em'}}>
                                                            <input className='form-control'
                                                                   value={this.state.codigoBaumusterFiltro}
                                                                   onChange={(e) => {
                                                                       this.setState({codigoBaumusterFiltro: e.target.value});
                                                                   }}
                                                                   placeholder='Cod.'
                                                                   onKeyDown={(e) => {
                                                                       if (e.keyCode === 13) {
                                                                           e.preventDefault();
                                                                           this.getBaumusterById(this.state.codigoBaumusterFiltro);
                                                                       } else if (e.keyCode === 8 || e.keyCode === 46){
                                                                           e.preventDefault();
                                                                           this.limpiaFiltrosBaumuster();
                                                                       }
                                                                   }}
                                                                   onBlur={() => {
                                                                       if(this.state.codigoBaumusterFiltro !== null && this.state.codigoBaumusterFiltro !== " " && this.state.codigoBaumusterFiltro !== ""){
                                                                           this.getBaumusterById(this.state.codigoBaumusterFiltro,'');
                                                                       }
                                                                   }}/>
                                                        </div>
                                                        <div className='input-group col-md-7' style={{width: '32.6em'}}>
                                                            <input className='form-control'
                                                                   value={this.state.nombreBaumusterFiltro}
                                                                   onChange={(e) => {
                                                                       this.setState({nombreBaumusterFiltro: e.target.value});
                                                                   }}
                                                                   placeholder='Nombre' readOnly={'readOnly'}/>
                                                            <span className='input-group-btn'>
                                  <button type='button' onClick={this.openModalBaumuster} className='btn btn'><span className='ion-search'/></button>
                                </span>
                                                        </div>
                                                        {
                                                            this.state.baumusterExiste === false &&
                                                            <Alert type='alert-warning alertModal' icon='ion-alert-circled'>
                                                                <p>El Baumuster no existe</p>
                                                            </Alert>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            {/*
                                            <div className='col-md-12'>
                                                <div className='form-group'>
                                                    <label className='control-label'>Configuraci&oacute;n</label>
                                                    <div className='row'>
                                                        <div className='col-md-5' style={{width: '9em'}}>
                                                            <input className='form-control input-group-left'
                                                                   value={this.state.codigoConfiguracionFiltro}
                                                                   onChange={(e) => {
                                                                       this.setState({codigoConfiguracionFiltro: e.target.value});
                                                                   }}
                                                                   placeholder='Cod.'
                                                                   onKeyDown={(e) => {
                                                                       if (e.keyCode === 13) {
                                                                           e.preventDefault();
                                                                           this.getConfiguracionById(this.state.codigoConfiguracionFiltro);
                                                                       } else if (e.keyCode === 8 || e.keyCode === 46){
                                                                           e.preventDefault();
                                                                           this.limpiaFiltrosConfiguracion();
                                                                       }
                                                                   }}
                                                                   onBlur={() => {
                                                                       if(this.state.codigoConfiguracionFiltro !== null && this.state.codigoConfiguracionFiltro !== " " && this.state.codigoConfiguracionFiltro !== ""){
                                                                           this.getConfiguracionById(this.state.codigoConfiguracionFiltro,'');
                                                                       }
                                                                   }}/>
                                                        </div>
                                                        <div className='input-group col-md-7' style={{width: '32.6em'}}>
                                                            <input className='form-control input-group-right-with-btn'
                                                                   value={this.state.nombreConfiguracionFiltro}
                                                                   onChange={(e) => {
                                                                       this.setState({nombreConfiguracionFiltro: e.target.value});
                                                                   }}
                                                                   placeholder='Nombre' readOnly={'readOnly'}/>
                                                            <span className='input-group-btn'>
                                  <button type='button' onClick={this.openModalConfiguracion} className='btn btn'><span className='ion-search'/></button>
                                </span>
                                                        </div>
                                                        {
                                                            this.state.configuracionExiste === false &&
                                                            <Alert type='alert-warning alertModal' icon='ion-alert-circled'>
                                                                <p>La configuracion no existe</p>
                                                            </Alert>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            */}
                                            <div className='col-md-6'>
                                                <div className='form-group'>
                                                    <label className='control-label'>SKU</label>
                                                    <input
                                                        id='codSKU' value={this.state.codigoSKUFiltro} onChange={(e) => { this.setState({ codigoSKUFiltro: e.target.value }); }}
                                                        className='form-control awesomplete' data-list='Raul Enrique, Juan Perez, Ana Pareces, Bendicto, Guztavo Altor, Fabiola Manuel' required='required'
                                                    />
                                                </div>
                                            </div>
                                            <div className='col-md-6'>
                                                <div className='form-group'>
                                                    <label className='control-label'>Cl&aacute;usula de Compra</label>
                                                    {/*<input
                                                        id='codSKU' value={this.state.checkClausulas} onChange={(e) => { this.setState({ codigoClausulaFiltro: e.target.value }); }}
                                                        className='form-control awesomplete' data-list='Raul Enrique, Juan Perez, Ana Pareces, Bendicto, Guztavo Altor, Fabiola Manuel' required='required'
                                                    />*/}
                                                    <ComboCheck
                                                        name='Clausula de Compra' idComponente={COMBO_CHECK_CLAUSULAS}
                                                        classMostrarComboCheck={this.state.classMostrarCompania}
                                                        onClickCheck={this.handleInputChangeComboCheck}
                                                        lista={!this.state.clausulas ? [] : this.state.clausulas}
                                                        id='id'
                                                        nombre='nombre'
                                                        total={this.state.checkClausulas.length}
                                                    />
                                                </div>
                                            </div>
                                            <div className='col-md-6'>
                                                <div className='form-group'>
                                                    <label className='control-label'>Compa&ntilde;&iacute;a</label>
                                                    <ComboCheck
                                                        name='Compañia' idComponente={COMBO_CHECK_COMPANIA}
                                                        classMostrarComboCheck={this.state.classMostrarCompania}
                                                        onClickCheck={this.handleInputChangeComboCheck}
                                                        lista={!this.props.companias ? [] : this.props.companias}
                                                        id='id'
                                                        nombre='nombre'
                                                        total={this.state.checkCompanias.length}
                                                    />
                                                </div>
                                            </div>
                                            <div className='col-md-6'>
                                                <div className='form-group'>
                                                    <label className='control-label'>Moneda</label>
                                                    <ComboCheck
                                                        name='Moneda' idComponente={COMBO_CHECK_MONEDA}
                                                        classMostrarComboCheck={this.state.classMostrarMoneda}
                                                        onClickCheck={this.handleInputChangeComboCheck}
                                                        lista={!this.props.monedas ? [] : this.props.monedas}
                                                        id='id'
                                                        nombre='nombre'
                                                        total={this.state.checkMoneda.length}
                                                    />
                                                </div>
                                            </div>
                                            <div className='col-md-6'>
                                                <div className='form-group'>
                                                    <label className='control-label'>Zona</label>
                                                    <ComboCheck
                                                        name='Zona' idComponente={COMBO_CHECK_ZONA}
                                                        classMostrarComboCheck={this.state.classMostrarZonas}
                                                        onClickCheck={this.handleInputChangeComboCheck}
                                                        lista={!this.props.zonas ? [] : this.props.zonas}
                                                        id='codZona'
                                                        nombre='desZona'
                                                        total={this.state.checkZonas.length}
                                                    />
                                                </div>
                                            </div>
                                            <div className='col-md-6'>
                                                <div className='form-group'>
                                                    <label className='control-label'>Tipo de adquisici&oacute;n</label>
                                                    <ComboCheck
                                                        name='Tipo de adquisición' idComponente={COMBO_CHECK_TIPOADQUISICION}
                                                        classMostrarComboCheck={this.state.classMostrarTipoAdquisicion}
                                                        onClickCheck={this.handleInputChangeComboCheck}
                                                        lista={!this.props.tipoAdquisicion ? [] : this.props.tipoAdquisicion}
                                                        id='codAdquisicion'
                                                        nombre='desAdquisicion'
                                                        total={this.state.checkTipoAdquisicion.length}
                                                    />
                                                </div>
                                            </div>

                                            {/*Modales*/}
                                            <div className='modal' role='dialog' data-backdrop='static'
                                                 style={{display: this.state.isOpenCliente}}>
                                                <div className='modal-dialog' role='document'>
                                                    <button className='btn btn-sm btn-blue modal-close'
                                                            data-dismiss='modal' onClick={this.closeModalCliente}>Cerrar
                                                        ventana
                                                    </button>
                                                    <div className='modal-content'>
                                                        <div className='modal-body'>
                                                            <h2 className='modal-title'>Buscar Cliente</h2>
                                                            <div className='row'>
                                                                <div className='col-md-12'>
                                                                    <div className='form-group'>
                                                                        <label className='control-label'>Nombre o
                                                                            Raz&oacute;n Social</label>
                                                                        <input className='form-control'
                                                                               value={this.state.nombreClienteInput}
                                                                               onChange={(e) => {
                                                                                   this.setState({nombreClienteInput: e.target.value});
                                                                               }}
                                                                               placeholder='Filtrar por nombre o razón social.'
                                                                               onKeyDown={(e) => {
                                                                                   if (e.keyCode === 13) {
                                                                                       e.preventDefault();
                                                                                       this.getClienteById(this.state.nombreClienteInput, 'cadena');
                                                                                   }
                                                                               }}/>
                                                                    </div>
                                                                </div>
                                                                <div className='col-md-6'>
                                                                    <div className='form-group'>
                                                                        <label className='control-label'>DNI</label>
                                                                        <input className='form-control'
                                                                               value={this.state.dniClienteInput}
                                                                               onChange={(e) => {
                                                                                   this.setState({dniClienteInput: e.target.value});
                                                                               }}
                                                                               placeholder='Ingrese DNI'
                                                                               onKeyDown={(e) => {
                                                                                   if (e.keyCode === 13) {
                                                                                       e.preventDefault();
                                                                                       this.getClienteById(this.state.dniClienteInput, 'dni');
                                                                                   }
                                                                               }}/>
                                                                    </div>
                                                                </div>
                                                                <div className='col-md-6'>
                                                                    <div className='form-group'>
                                                                        <label className='control-label'>RUC</label>
                                                                        <input className='form-control'
                                                                               value={this.state.rucClienteInput}
                                                                               onChange={(e) => {
                                                                                   this.setState({rucClienteInput: e.target.value});
                                                                               }}
                                                                               placeholder='Ingrese RUC'
                                                                               onKeyDown={(e) => {
                                                                                   if (e.keyCode === 13) {
                                                                                       e.preventDefault();
                                                                                       this.getClienteById(this.state.rucClienteInput, 'ruc');
                                                                                   }
                                                                               }}/>
                                                                    </div>
                                                                </div>
                                                                <div className='col-md-6'></div>
                                                                <div className='col-md-6'>
                                                                    <button className='btn btn-primary pull-right'
                                                                            onClick={this.obtieneClientes}>Buscar
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <hr></hr>
                                                            <div className='row'>
                                                                <div className='col-md-12'>
                                                                    <div className='pageHead-tableConf-pagCols pull-right'>
                                                                        <nav className='pag'>
                                                                            <p className='pag-label'>
                                                                                <span>{this.state.nInicioCliente}</span><span> -</span><span> {this.state.nFinCliente}</span><span> de</span><span> {this.state.totalClientesRegistros}</span>
                                                                            </p>
                                                                            <div className='pag-arrows'>
                                                                                <a className='btn btn-default pag-link checkDeGrillaCerrar'
                                                                                   title='Anterior' onClick={this.atrasCliente}><i
                                                                                    className='ion-chevron-left'/></a>
                                                                                <a className='btn btn-default pag-link checkDeGrillaCerrar'
                                                                                   title='Siguiente' onClick={this.siguienteCliente}><i
                                                                                    className='ion-chevron-right'/></a>
                                                                            </div>
                                                                        </nav>
                                                                    </div>
                                                                    <table className='table table-hover'>
                                                                        <thead className='table-head'>
                                                                        <tr>
                                                                            <th>C&oacute;digo</th>
                                                                            <th>Nombre</th>
                                                                            <th>RUC</th>
                                                                            <th>DNI</th>
                                                                            <th></th>
                                                                        </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                        <TableTr
                                                                            clientes={this.state.clienteResponse}
                                                                            fnClienteSelected={this.fnClienteSelected}
                                                                        />
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='modal' role='dialog' data-backdrop='static'
                                                 style={{display: this.state.isOpenAsesor}}>
                                                <div className='modal-dialog' role='document'>
                                                    <button className='btn btn-sm btn-blue modal-close'
                                                            data-dismiss='modal' onClick={this.closeModalAsesor}>Cerrar
                                                        ventana
                                                    </button>
                                                    <div className='modal-content'>
                                                        <div className='modal-body'>
                                                            <h2 className='modal-title'>Buscar Asesor</h2>
                                                            <div className='row'>
                                                                <div className='col-md-9'>
                                                                    <div className="col-md-3 form-group">
                                                                        <label className='control-label'>Nombre </label>
                                                                    </div>
                                                                    <div className="col-md-9 form-group">
                                                                        <input className='form-control'
                                                                            value={this.state.nombreAsesorInput}
                                                                            onChange={(e) => {
                                                                                this.setState({nombreAsesorInput: e.target.value});
                                                                            }}
                                                                            placeholder='Filtrar por nombre...'
                                                                            onKeyDown={(e) => {
                                                                                if (e.keyCode === 13) {
                                                                                    e.preventDefault();
                                                                                    this.getAsesorById(this.state.nombreAsesorInput, 'nombre');
                                                                                }
                                                                            }}/>
                                                                    </div>
                                                                </div>
                                                                <div className='col-md-9'>
                                                                        <div className="col-md-3 form-group">
                                                                            <label className='control-label'>C&oacute;digo </label>
                                                                        </div>
                                                                        <div className="col-md-9 form-group">
                                                                            <input className='form-control'
                                                                                value={this.state.codigoAsesorInput}
                                                                                onChange={(e) => {
                                                                                    this.setState({codigoAsesorInput: e.target.value});
                                                                                }}
                                                                                placeholder='Filtrar por c&oacute;digo...'
                                                                                onKeyDown={(e) => {
                                                                                    if (e.keyCode === 13) {
                                                                                        e.preventDefault();
                                                                                        this.getAsesorById(this.state.codigoAsesorInput, 'codigo');
                                                                                    }
                                                                                }}/>
                                                                        </div>
                                                                </div>
                                                                <div className='col-md-3'>
                                                                    <button className='btn btn-primary pull-right'
                                                                            onClick={this.obtieneAsesores}>Buscar
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <hr></hr>
                                                            <div className='row'>
                                                                <div className='col-md-12'>
                                                                    <div className='pageHead-tableConf-pagCols pull-right'>
                                                                        <nav className='pag'>
                                                                            <p className='pag-label'>
                                                                                <span>{this.state.nInicioAsesor}</span><span> -</span><span> {this.state.nFinAsesor}</span><span> de</span><span> {this.state.totalAsesoresRegistros}</span>
                                                                            </p>
                                                                            <div className='pag-arrows'>
                                                                                <a className='btn btn-default pag-link checkDeGrillaCerrar'
                                                                                   title='Anterior' onClick={this.atrasAsesor}><i
                                                                                    className='ion-chevron-left'/></a>
                                                                                <a className='btn btn-default pag-link checkDeGrillaCerrar'
                                                                                   title='Siguiente' onClick={this.siguienteAsesor}><i
                                                                                    className='ion-chevron-right'/></a>
                                                                            </div>
                                                                        </nav>
                                                                    </div>
                                                                    <table className='table table-hover'>
                                                                        <thead className='table-head'>
                                                                        <tr>
                                                                            <th></th>
                                                                            <th>Vendedor</th>
                                                                            <th>C&oacute;digo</th>
                                                                        </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                        <TableTrAsesor
                                                                            asesores={this.state.asesorResponse}
                                                                            fnAsesorSelected={this.fnAsesorSelected}
                                                                        />
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='modal' role='dialog' data-backdrop='static'
                                                 style={{display: this.state.isOpenBaumuster}}>
                                                <div className='modal-dialog' role='document'>
                                                    <button className='btn btn-sm btn-blue modal-close'
                                                            data-dismiss='modal' onClick={this.closeModalBaumuster}>Cerrar
                                                        ventana
                                                    </button>
                                                    <div className='modal-content'>
                                                        <div className='modal-body'>
                                                            <h2 className='modal-title'>Buscar Baumuster</h2>
                                                            <div className='row'>
                                                                <div className='col-md-9'>
                                                                    <div className='col-md-3 form-group'>
                                                                        <label className='control-label'>Nombre </label>
                                                                    </div>
                                                                    <div className='col-md-9 form-group'>
                                                                        <input className='form-control'
                                                                               value={this.state.nombreBaumusterInput}
                                                                               onChange={(e) => {
                                                                                   this.setState({nombreBaumusterInput: e.target.value});
                                                                               }}
                                                                               placeholder='Filtrar por nombre...'
                                                                               onKeyDown={(e) => {
                                                                                   if (e.keyCode === 13) {
                                                                                       e.preventDefault();
                                                                                       this.getBaumusterById(this.state.nombreBaumusterInput, 'nombre');
                                                                                   }
                                                                               }}/>
                                                                    </div>
                                                                </div>
                                                                <div className='col-md-9'>
                                                                    <div className='col-md-3 form-group'>
                                                                        <label className='control-label'>C&oacute;digo </label>
                                                                    </div>
                                                                    <div className='col-md-9 form-group'>
                                                                        <input className='form-control'
                                                                               value={this.state.codigoBaumusterInput}
                                                                               onChange={(e) => {
                                                                                   this.setState({codigoBaumusterInput: e.target.value});
                                                                               }}
                                                                               placeholder='Filtrar por c&oacute;digo...'
                                                                               onKeyDown={(e) => {
                                                                                   if (e.keyCode === 13) {
                                                                                       e.preventDefault();
                                                                                       this.getBaumusterById(this.state.codigoBaumusterInput, 'codigo');
                                                                                   }
                                                                               }}/>
                                                                    </div>
                                                                </div>
                                                                <div className='col-md-3'>
                                                                    <button className='btn btn-primary pull-right'
                                                                            onClick={this.obtieneBaumuster}>Buscar
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <hr></hr>
                                                            <div className='row'>
                                                                <div className='col-md-12'>
                                                                    <div className='pageHead-tableConf-pagCols pull-right'>
                                                                        <nav className='pag'>
                                                                            <p className='pag-label'>
                                                                                <span>{this.state.nInicioBaumuster}</span><span> -</span><span> {this.state.nFinBaumuster}</span><span> de</span><span> {this.state.totalBaumusterRegistros}</span>
                                                                            </p>
                                                                            <div className='pag-arrows'>
                                                                                <a className='btn btn-default pag-link checkDeGrillaCerrar'
                                                                                   title='Anterior' onClick={this.atrasBaumuster}><i
                                                                                    className='ion-chevron-left'/></a>
                                                                                <a className='btn btn-default pag-link checkDeGrillaCerrar'
                                                                                   title='Siguiente' onClick={this.siguienteBaumuster}><i
                                                                                    className='ion-chevron-right'/></a>
                                                                            </div>
                                                                        </nav>
                                                                    </div>
                                                                    <table className='table table-hover'>
                                                                        <thead className='table-head'>
                                                                        <tr>
                                                                            <th></th>
                                                                            <th>Modelo</th>
                                                                            <th>C&oacute;digo</th>
                                                                        </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                        <TableTrBaumuster
                                                                            baumusters={this.state.baumusterResponse}
                                                                            fnBaumusterSelected={this.fnBaumusterSelected}
                                                                        />
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='modal' role='dialog' data-backdrop='static'
                                                 style={{display: this.state.isOpenConfiguracion}}>
                                                <div className='modal-dialog' role='document'>
                                                    <button className='btn btn-sm btn-blue modal-close'
                                                            data-dismiss='modal' onClick={this.closeModalConfiguracion}>Cerrar
                                                        ventana
                                                    </button>
                                                    <div className='modal-content'>
                                                        <div className='modal-body'>
                                                            <h2 className='modal-title'>Buscar Configuraci&oacute;n</h2>
                                                            <div className='row'>
                                                                <div className='col-md-6'>
                                                                    <div className='form-group'>
                                                                        <label className='control-label'>Configuraci&oacute;n </label>
                                                                        <input className='form-control'
                                                                               value={this.state.nombreConfiguracionInput}
                                                                               onChange={(e) => {
                                                                                   this.setState({nombreConfiguracionInput: e.target.value});
                                                                               }}
                                                                               placeholder='Filtrar por nombre.'/>
                                                                    </div>
                                                                </div>
                                                                <div className='col-md-6'>
                                                                    <div className='form-group'>
                                                                        <label className='control-label'>SKU </label>
                                                                        <input className='form-control'
                                                                               value={this.state.codigoSKUInput}
                                                                               onChange={(e) => {
                                                                                   this.setState({codigoSKUInput: e.target.value});
                                                                               }}
                                                                               placeholder='Filtrar por nombre.'/>
                                                                    </div>
                                                                </div>
                                                                <div className='col-md-6'></div>
                                                                <div className='col-md-6'>
                                                                    <button className='btn btn-primary pull-right'
                                                                            onClick={this.obtieneConfiguracion}>Buscar
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <hr></hr>
                                                            <div className='row'>
                                                                <div className='col-md-12'>
                                                                    <div className='pageHead-tableConf-pagCols pull-right'>
                                                                        <nav className='pag'>
                                                                            <p className='pag-label'>
                                                                                <span>{this.state.nInicioConf}</span><span> -</span><span> {this.state.nFinConf}</span><span> de</span><span> {this.state.totalConfiguracionRegistros}</span>
                                                                            </p>
                                                                            <div className='pag-arrows'>
                                                                                <a className='btn btn-default pag-link checkDeGrillaCerrar'
                                                                                   title='Anterior' onClick={this.atrasConfig}><i
                                                                                    className='ion-chevron-left'/></a>
                                                                                <a className='btn btn-default pag-link checkDeGrillaCerrar'
                                                                                   title='Siguiente' onClick={this.siguienteConfig}><i
                                                                                    className='ion-chevron-right'/></a>
                                                                            </div>
                                                                        </nav>
                                                                    </div>
                                                                    <table className='table table-hover'>
                                                                        <thead className='table-head'>
                                                                        <tr>
                                                                            <th>Configuraci&oacute;n</th>
                                                                            <th>SKU</th>
                                                                            <th></th>
                                                                        </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                        <TableTrConfiguracion
                                                                            configuraciones={this.state.configuracionResponse}
                                                                            fnConfiguracionSelected={this.fnConfiguracionSelected}
                                                                        />
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='modal extraFilter' role='dialog' data-backdrop='static'
                                                 style={{zIndex: '2000', display: this.state.muestraLoad2}}>
                                                <div className='modal-dialog modal-sm' role='document'>
                                                    <FadeLoader color={'#F8A14A'} loading/>
                                                </div>
                                            </div>
                                        </div>

                                        /*REQ-86298*/}
                                    <div className='row modal-actions'>
                                        <div className='col-xs-12 col-sm-6'>
                                            <button className='btn btn-default btn-block' data-dismiss='modal'
                                                    onClick={this.cancelarModalMasFiltros}>Cancelar
                                            </button>
                                        </div>
                                        <div className='col-xs-12 col-sm-6'>
                                            <button className='btn btn-primary btn-block' data-dismiss='modal'
                                                    onClick={this.filtrarMas}>Filtrar
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {
                        this.functionValidacion()
                    }
                    <div className='alert alert-warning' role='alert' id='alertFichaVenta'
                         style={{display: 'none', zIndex: '2000', backgroundColor: this.state.colorBackground}}>
                        <i className={this.state.iconAlert}/>
                        <p>{this.state.mensajeAlert}</p>
                    </div>

                    {
                        this.props.fichasVenta && this.props.fichasVenta.error ?
                            <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
                                <p>Hubo un error con el servicio de listar fichasVenta</p>
                            </Alert> : null
                    }

                    {
                        this.props.areasVenta && this.props.areasVenta.error ?
                            <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
                                <p>Hubo un error con el servicio de listar areasVenta</p>
                            </Alert> : null
                    }

                    {
                        this.props.familias && this.props.familias.error ?
                            <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
                                <p>Hubo un error con el servicio de listar familias</p>
                            </Alert> : null
                    }

                    {
                        this.props.filiales && this.props.filiales.error ?
                            <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
                                <p>Hubo un error con el servicio de listar filiales</p>
                            </Alert> : null
                    }

                    {
                        this.props.companias && this.props.companias.error ?
                            <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
                                <p>Hubo un error con el servicio de listar companias</p>
                            </Alert> : null
                    }

                    {
                        this.props.zonas && this.props.zonas.error ?
                            <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
                                <p>Hubo un error con el servicio de listar zonas</p>
                            </Alert> : null
                    }

                    {
                        this.props.tipoFichas && this.props.tipoFichas.error ?
                            <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
                                <p>Hubo un error con el servicio de listar tipoFichas</p>
                            </Alert> : null
                    }

                    {
                        this.props.monedas && this.props.monedas.error ?
                            <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
                                <p>Hubo un error con el servicio de listar monedas</p>
                            </Alert> : null
                    }

                    {
                        this.props.tipoFichas && this.props.tipoFichas.error ?
                            <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
                                <p>Hubo un error con el servicio de listar tipoFichas</p>
                            </Alert> : null
                    }

                    {
                        this.props.tipoPagos && this.props.tipoPagos.error ?
                            <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
                                <p>Hubo un error con el servicio de listar tipoPagos</p>
                            </Alert> : null
                    }

                    {
                        this.props.tipoAdquisicion && this.props.tipoAdquisicion.error ?
                            <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
                                <p>Hubo un error con el servicio de listar tipoAdquisicion</p>
                            </Alert> : null
                    }

                    {
                        this.props.vendedores && this.props.vendedores.error ?
                            <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
                                <p>Hubo un error con el servicio de listar vendedores</p>
                            </Alert> : null
                    }

                    {
                        this.state.clausulas && this.state.clausulas.error ?
                            <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
                                <p>Hubo un error con el servicio de listar Claúsulas de Compra</p>
                            </Alert> : null
                    }
                    { this.state.alertSuccessOpen?
                    <Alert type='alert-success' icon='ion-checkmark-circled' >
                        <p>{this.state.alertSuccessMessage}</p>
                    </Alert>:null
                    }
                    { this.state.alertErrorOpen?
                    <Alert type='alert-warning' icon='ion-alert-circled' closeAlert={this.closeAlertError}>
                        <p>{this.state.alertErrorMessage}</p>
                    </Alert>:null
                    }

                </div>
            </ErrorUIComponent>
        );
    }
}

function mapStateToProps(state) {
    return {
        fichasVenta: state.fichasVenta,
        areasVenta: state.areasVenta,
        familias: state.familias,
        filiales: state.filiales,
        companias: state.companias,
        zonas: state.zonas,
        tipoFichas: state.tipoFichas,
        monedas: state.monedas,
        tipoPagos: state.tipoPagos,
        tipoAdquisicion: state.tipoAdquisicion,
        vendedores: state.vendedores
    };
}

export default connect(mapStateToProps,
    {
        fetchFichasVenta,
        fetchReporteConsultaFichaVenta,
        fetchReporteConsultaFichaVentaBonos,/*Req. 92349 ebarboza 18 06 2021*/
        fetchAreasVenta,
        loadFichasVenta,
        fetchFamilia,
        fetchFiliales,
        fetchCompanias,
        fetchZonas,
        fetchTipoFichas,
        fetchMonedas,
        fetchTipoPagos,
        fetchTipoAdquisicion,
        fetchFamiliaPorAreaVta,
        fetchVendedores,
        clearVendedores,
        fetchObtenerClientes,
        fetchobtenerAsesor,
        fetchObtenerModelo,
        fetchObtenerConfiguracion,
        fetchObtenerClausulaComra
    })(IndexFichaVenta);



// WEBPACK FOOTER //
// ./src/containers/IndexFichaVenta.js